// import { ExitToApp, NoteAdd, Save } from "@mui/icons-material";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   Stack,
//   TextField,
//   Typography
// } from "@mui/material";
// import axios from "axios";
// import _ from "lodash";
// import moment from "moment";
// import React, { Fragment, memo, useEffect, useState } from "react";
// import QRCode from "react-qr-code";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { BarLoader } from "react-spinners";
// import failed from "../../../../../assets/images/failed.png";
// import success from "../../../../../assets/images/success.gif";
// import {
//   onPressButton,
//   setThermalData,
// } from "../../../../../components/hooks/printPdf/thermalData";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import Loader from "../../../../../components/loader/loader";
// import DialogCancel from "../../../../../components/utils/dialogCancel/dialogCancel";
// const CustomerInfo = ({
//   data,
//   docName,
//   postData,
//   setPostData,
//   docNameDefault,
//   thisBill,
//   setThisBill,
//   setBillPoints,
//   billPoints,
//   setReward,
//   op,
//   setReturnAmnt,
//   returnAmnt,
//   enableRedeem,
//   member,
//   selectedMode,
//   disc1
// }) => {
//   const [open, setOpen] = useState(false);
//   const [l_points, setLPoints] = useState("");
//   const [l_amt, setLAmt] = useState("");
//   const [r_points, setRPoints] = useState("");
//   const [r_amt, setRAmt] = useState(0);
//   const [points, setPoints] = useState(0.0);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [dialogClose, setDialogClose] = useState(false);
//   const [isLoader, setIsLoader] = useState(false); //loader
//   const outlet_id = localStorage.getItem("outlet_id");
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [paymentState, setPaymentState] = useState(null);
//   const [shouldPoll, setShouldPoll] = useState(false);
//   const [dialogContent, setDialogContent] = useState("");
//   const [merchantId, setMerchantId] = useState("");
//   const [url, setUrl] = useState("");
//   const [qrCode, setQrCode] = useState("");
//   const [qrOpen, setQrOpen] = useState(false);
//   const [linkOpen, setLinkOpen] = useState(false);
//   const [mergedBillDate, setMergedBillDate] = useState("");
//   const [cancelStatus, setCancelStatus] = useState(false);
//   const [responseData, setResponseData] = useState(null);
//   const [payType, setpayType] = useState([]);
//   const [redeemedPonits, setRedeemedPoints] = useState(0.0);
//   const [countdown, setCountdown] = useState(3);
//   const [lessAmount, setLessAmount] = useState(0);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [phonePayHistory, setPhonePayHistory] = useState({
//     docno: "",
//     transaction_date: moment().format("YYYY-MM-DD"),
//     merchant_order_id: "",
//     transaction_id: "",
//     response_json: {
//       data: "data response",
//     },
//     request_json: {
//       data: "data request",
//     },
//     phone_no: "",
//   });
//   const [paymentDetails, setPaymentDetails] = useState({
//     card: "0",
//     cash: "0",
//     upi: "0",
//   });
//   const onClickCancel = () => {
//     setDialogClose(false);
//   };
//   const onClickExit = () => {
//     navigate("/");
//   };
//   // console.log(paymentDetails)
//   const handleExit = () => {
//     setDialogClose(true);
//   };
//   // console.log(phonePayHistory)
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   let totalAmt = 0;
//   totalAmt += data.reduce(
//     (accumulator, item) => accumulator + parseFloat(item.totalAmt),
//     0
//   );

//   let gstAmt = 0;
//   gstAmt += data.reduce(
//     (accumulator, item) => accumulator + parseFloat(item.gstAmt),
//     0
//   );

//   // let discountamt = 0;
//   // discountamt += data.reduce(
//   //   (accumulator, item) => accumulator + parseFloat(item.discountamt),
//   //   0
//   // );
//   let discountamt = data.reduce(
//     // (accumulator, item) => accumulator + (parseFloat(item.rate1 || 0) + parseFloat(item.gstAmt || 0) - parseFloat(item.disc1))* item.qty,
//     // 0
//     (accumulator, item) => accumulator + (parseFloat(item.disc1 || 0) * parseFloat(item.mrp1 || 0)  / 100)* item.qty,
//     // (accumulator, item) => accumulator + (parseFloat(item.disc1 || 0) * parseFloat(item.rate1 || 0)  / 100)* item.qty,
//     0
//   );
//   console.log(totalAmt,"datadatadata");

//   // let discountamt = data.reduce((accumulator, item) => {
//   //   // Only calculate discount if disc1 is not 100%
//   //   if (parseFloat(item.disc1 || 0) === 100) {
//   //     return accumulator; // Skip adding discount if it's 100%
//   //   }

//   //   // Calculate the discount for non-100% disc1
//   //   return accumulator + (parseFloat(item.disc1 || 0) * parseFloat(item.rate1 || 0) / 100) * item.qty;
//   // }, 0);

//   // let discountamt = parseFloat(disc1 + gstAmt ).toFixed(0);
// // dis_amt = parseFloat(
// //   ((rate1 - (rate1 * (100 - disc1)) / 100) * qty)
// // ).toFixed(0);

//   let cessAmt = 0;
//   cessAmt += data.reduce(
//     (accumulator, item) => accumulator + parseFloat(item.cessAmt),
//     0
//   );
//   let netTotal = 0;

//   if (enableRedeem) {
//     netTotal = parseFloat(totalAmt + gstAmt - points - lessAmount - returnAmnt).toFixed(0);
//   } else {
//     netTotal = parseFloat(totalAmt + gstAmt - lessAmount - returnAmnt).toFixed(0);
//   }
//   console.log(points,"enableRedeem");

//   // let subNetTotal = parseFloat(totalAmt + gstAmt - lessAmount).toFixed(0);
//   let subNetTotal = parseFloat(totalAmt + gstAmt).toFixed(0);
//   // let subNetTotal = parseFloat(totalAmt + gstAmt - discountamt).toFixed(0);

//   const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",];
//   const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen", ];
//   const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",];
//   const thousands = ["", "Thousand", "Million", "Billion", "Trillion"];
//   const buttonStyles = [
//     { borderColor: "blue", color: "blue", hoverColor: "#e0f7fa" },
//     { borderColor: "green", color: "green", hoverColor: "#e8f5e9" },
//     { borderColor: "violet", color: "violet", hoverColor: "#ee82ee26" },
//   ];
//   const convertNumber = (num) => {
//     if (num === 0) return "Zero";

//     let words = "";
//     for (let i = 0; num > 0; i++) {
//       if (num % 1000 !== 0) {
//         words = convertHundreds(num % 1000) + " " + thousands[i] + " " + words;
//       }
//       num = Math.floor(num / 1000);
//     }
//     return words.trim();
//   };
//   // console.log(billPoints.thisBill)
//   const convertHundreds = (num) => {
//     if (num >= 100) {
//       return (
//         units[Math.floor(num / 100)] + " Hundred " + convertTens(num % 100)
//       );
//     } else {
//       return convertTens(num);
//     }
//   };

//   const convertTens = (num) => {
//     if (num < 10) return units[num];
//     else if (num < 20) return teens[num - 10];
//     else return tens[Math.floor(num / 10)] + " " + units[num % 10];
//   };

//   const Design = ({ title, value }) => (
//     <div className="flex items-center">
//       <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>{title}</Typography>
//       <Typography variant="h6" textAlign="right" sx={{ fontWeight: 600, width: "100%", padding: 0.5 }}>{parseFloat(value).toFixed(0)}</Typography>
//     </div>
//   );

//   function hanldleDialog() {
//     setOpenDialog(false);
//     setPaymentDetails((prev) => ({ ...prev, card: "0", cash: "0", upi: "0" }));
//   }
//   function handleApiData() {
//     console.log(postData,"postdata")
//     setIsLoader(true);
//     axios
//       .post(`/v1/outlet_sales_master`, postData)
//       .then((res) => {
//         fetchBill(res.data.docno);
//         setIsLoader(false);
//       })
//       .catch((err) => {
//         // console.log(err);
//         setIsLoader(false);
//         dispatch(
//           setSnackbar(true, "error", err.response.data.errors[0].message)
//         );
//       });
//   }

//   function fetchBill(e) {
//     axios
//       .post(`/v1/outlet_sales_master/getall`, { docno: e })
//       .then((res) => {
//         // console.log(res)

//         dispatch(
//           setThermalData({
//             tableData: tableData,
//             TotalData: TotalData,
//             companyInfo: res.data,
//             totalText: convertNumber(Math.round(netTotal)),
//             redeemedValue: enableRedeem ? points : 0,
//             lessAmount: lessAmount,
//           })
//         );
//         dispatch(onPressButton());
//         const input = docName.replace(/\//g, "_");
//         const name = `BillNo_${input}`;
//         navigate(`/sales/${name}`);
//       })
//       .catch((err) => {
//         // console.log(err)
//         dispatch(
//           setSnackbar(true, "error", err.response.data.errors[0].message)
//         );
//       });
//   }

//   function handleMixedData() {
//     if (paymentDetails.upi > 0) {
//       setOpen(true);
//       setOpenDialog(false);
//     } else {
//       handleApiData();
//     }
//   }
//   function handlePaymentClose() {
//     setOpen(false);
//     if (paymentDetails.upi > 0) {
//       setOpenDialog(true);
//     }
//   }

//   function handleSubmit() {
//     if (isSubmitting) return; // Prevent double submission
//     setIsSubmitting(true); // Disable the button

//     if (postData.partycode === "") {
//       dispatch(setSnackbar(true, "error", "Please select party Name"));
//       setIsSubmitting(false);
//     } else if (postData.outlet_sales_details.length === 0) {
//       dispatch(setSnackbar(true, "error", "Please fill table"));
//       setIsSubmitting(false);
//     } else if (postData.salesman_id === "") {
//       dispatch(setSnackbar(true, "error", "Please Select Salesman"));
//       setIsSubmitting(false);
//     } else if (postData.mode === "" || postData.mode === null) {
//       dispatch(setSnackbar(true, "error", "Select Payment mode"));
//       setIsSubmitting(false);
//     } else if (postData.mode === "upi") {
//       if (postData.mobile === "") {
//         dispatch(setSnackbar(true, "error", "Please enter the mobile Number"));
//         setIsSubmitting(false);
//       } else if (postData.mobile.length !== 10) {
//         dispatch(setSnackbar(true, "error", "Please enter 10 digit mobile Number"));
//         setIsSubmitting(false);
//       } else {
//         setOpen(true);
//       }
//     } else if (postData.mode === "mixed") {
//       setOpenDialog(true);
//       setPaymentDetails((prev) => ({
//         ...prev,
//         cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
//         // cash: netTotal,

//       }));

//     } else {
//       handleApiData();
//     }
//      if (postData.channels === "" || postData.channels === null) {
//       dispatch(setSnackbar(true, "error", "Select Channel"));
//       return;
//     }

//     // setTimeout(() => setIsSubmitting(false), 2000); // Re-enable button after a delay or after operation completion
//   }
//   console.log(data,"salesprint1233");

//   // function handleSubmit() {
//   //   if (isSubmitting) return; // Prevent double submission

//   //   if (postData.partycode === "") {
//   //     dispatch(setSnackbar(true, "error", "Please select party Name"));
//   //     return;
//   //   }

//   //   if (postData.outlet_sales_details.length === 0) {
//   //     dispatch(setSnackbar(true, "error", "Please fill table"));
//   //     return;
//   //   }

//   //   if (postData.salesman_id === "") {
//   //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
//   //     return;
//   //   }
//   //   // if (postData.party_name === "" && postData.mobile === "") {
//   //   //   dispatch(setSnackbar(true, "error", "Please enter Party name"));
//   //   //   return;
//   //   // }
//   //   // if ((postData.party_name === "" || postData.mobile === "") && !(postData.party_name === "" && postData.mobile === "")) {
//   //   //   dispatch(setSnackbar(true, "error", "Please enter Party name and Mobile number"));
//   //   //   return;
//   //   // }
//   //   if (postData.party_name === "" && postData.mobile !== "") {
//   //     dispatch(setSnackbar(true, "error", "Please enter Customer name"));
//   //     return;
//   //   }

//   //   if (postData.mobile === "" && postData.party_name !== "") {
//   //     dispatch(setSnackbar(true, "error", "Please enter Mobile number"));
//   //     return;
//   //   }

//   //   if (postData.mode === "" || postData.mode === null) {
//   //     dispatch(setSnackbar(true, "error", "Select Payment mode"));
//   //     return;
//   //   }
//   //   if (postData.channels === "" || postData.channels === null) {
//   //     dispatch(setSnackbar(true, "error", "Select Channel"));
//   //     return;
//   //   }

//   //   // if (postData.mode === "upi") {
//   //   //   if (postData.mobile === "") {
//   //   //     dispatch(setSnackbar(true, "error", "Please enter the mobile Number"));
//   //   //     return;
//   //   //   } else if (postData.mobile.length !== 10) {
//   //   //     dispatch(setSnackbar(true, "error", "Please enter 10 digit mobile Number"));
//   //   //     return;
//   //   //   } else {
//   //   //     setOpen(true); // This is UI only, no need to block with isSubmitting
//   //   //     return;
//   //   //   }
//   //   // }

//   //   if (postData.mode === "mixed") {
//   //     setOpenDialog(true);
//   //     setPaymentDetails((prev) => ({
//   //       ...prev,
//   //       cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
//   //     }));
//   //     return; // No need for isSubmitting
//   //   }

//   //   // ✅ Actual submission
//   //   setIsSubmitting(true);
//   //   handleApiData();
//   // }

//   const tableData = data.map((val) => ({
//     pro_name: val.pro_name,
//     cat_name: val.cat_name,
//     hsn: val.hsn,
//     pur_rate: val.pur_rate,
//     sale_rate: val.sale_rate,
//     mrp: val.mrp,
//     qty: val.qty,
//     disc1: val.disc1,
//     cgstPerc: val.gst,
//     cgstAmnt: val.gstAmt,
//     totalAmt: val.totalAmt,
//   }));

//   const TotalData = {
//     returnAmnt: returnAmnt,
//     sub_total: totalAmt,
//     gst: gstAmt,
//     totalAmount: parseFloat(Math.round(netTotal)).toFixed(0),
//     roundOff: parseFloat(Math.round(netTotal).toFixed(0) - netTotal).toFixed(0),
//   };

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;

//     const numericValue = value.replace(/[^0-9]/g, "");

//     setPaymentDetails((prevDetails) => {
//       const updatedDetails = { ...prevDetails, [name]: numericValue };

//       const cardAmount = Number(updatedDetails.card) || 0;
//       const upiAmount = Number(updatedDetails.upi) || 0;
//       const totalAmount = cardAmount + upiAmount;

//       const initialAmount =
//         returnAmnt !== "" ? netTotal  : netTotal;

//       if (totalAmount > initialAmount) {
//         updatedDetails[name] = "";
//         updatedDetails.cash =
//           initialAmount -
//           (Number(updatedDetails.card) || 0) -
//           (Number(updatedDetails.upi) || 0);
//       } else {
//         updatedDetails.cash = initialAmount - totalAmount;
//       }

//       return updatedDetails;
//     });
//   };

//   // console.log(billPoints )
//   // console.log(reward,'Reward Points','Default Point',billPoints.defaultPoint)
//   let redeemPoints = 0;
//   // function handleRedeem() {
//   //   if (postData.mobile !== "" && postData.mobile.length===10 && op) {
//   //     const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));
//   //     if (netTotal >= r_amt) {
//   //       const total_reward_points = parseFloat(
//   //         billPoints.defaultPoint + loyalty_earned
//   //       ).toFixed(0);
//   //       // const total_reward_points1 = parseFloat(reward) + loyalty_earned
//   //       const redemed_value = total_reward_points * (r_points / 100);
//   //       const new_bal_points = total_reward_points - redemed_value;
//   //       setReward(billPoints.defaultPoint + loyalty_earned);
//   //       console.log(loyalty_earned,"loyal_earned ", "total_reward_points :", total_reward_points, "Reward :", billPoints.defaultPoint + loyalty_earned,"new_bal_points :",new_bal_points,"redeem :",redemed_value);
//   //       // const rewardPoint = parseFloat(reward) + (totalAmt * (parseFloat(l_points) / parseFloat(l_amt)))
//   //       // const updatedReward = rewardPoint - (rewardPoint * r_points / 100)

//   //       // const subAmt = totalAmt - parseFloat(rewardPoint - updatedReward).toFixed(0)
//   //       // setSubTot(subAmt)
//   //       setRedeemedPoints(redemed_value);
//   //       console.log(redeemedPonits);
//   //       setThisBill(loyalty_earned);
//   //       setBillPoints((prev) => ({ ...prev, total: new_bal_points }));
//   //       if (redemed_value > netTotal) {
//   //         // console.log('thappu', totalAmt * (r_points / 100))
//   //         setPoints(Math.round(netTotal * (r_points / 100)));
//   //         console.log('first')
//   //         setPostData((prevState) => ({...prevState, loyalty_earned: loyalty_earned, loyalty_redem: netTotal * (r_points / 100),balance_points:parseFloat(new_bal_points).toFixed(0),}));
//   //       } else {
//   //         setRedeemedPoints(redemed_value);
//   //         console.log(redeemedPonits);
//   //         setPoints(Math.round(redemed_value).toFixed(0));
//   //         console.log(points,"second");
//   //         setPostData((prevState) => ({...prevState, loyalty_earned: loyalty_earned, loyalty_redem: Number(redemed_value).toFixed(0), balance_points: parseFloat(total_reward_points).toFixed(0),}));
//   //       }
//   //     } else {
//   //       setPoints(0);
//   //       setBillPoints((prev) => ({ ...prev, total: 0 }));
//   //       setThisBill(0);
//   //     }
//   //   }
//   //   else if(postData.mobile.length===10 && member){
//   //     const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));
//   //     console.log(postData.balance_points, billPoints.defaultPoint + loyalty_earned, "Enna ithu", billPoints.defaultPoint, loyalty_earned)
//   //     setPostData((prevState) => ({...prevState, balance_points: billPoints.defaultPoint + loyalty_earned,}))
//   //   }
//   //   else{
//   //     setPoints(0)
//   //     setPostData((prevState) => ({...prevState, loyalty_earned: 0, loyalty_redem: 0, }));
//   //     // setPostData((prevState) => ({...prevState, loyalty_earned: 0, loyalty_redem: 0, balance_points: 0,}));
//   //     console.log('vara kudathu!', op)
//   //   }
//   // }
//   // function handleNewRedeem() {
//   //   if ( postData.mobile.length===10  ) {
//   //     console.log(member,'Ithan da Members', billPoints, postData.balance_points)
//   //     const loyalty_earned =
//   //       netTotal * (parseFloat(l_points) / parseFloat(l_amt));
//   //     if (netTotal >= r_amt) {
//   //       const total_reward_points = parseFloat(billPoints.defaultPoint + loyalty_earned).toFixed(0);
//   //       // const total_reward_points1 = parseFloat(reward) + loyalty_earned
//   //       const redemed_value = total_reward_points * (r_points / 100);
//   //       const new_bal_points = total_reward_points - redemed_value;
//   //       setReward(billPoints.defaultPoint + loyalty_earned);
//   //       console.log('Yaar ivan',loyalty_earned, "loyal_earned ", "total_reward_points :", total_reward_points, "Reward :", billPoints.defaultPoint + loyalty_earned, "new_bal_points :", new_bal_points, "redeem :", redemed_value, "third" );

//   //       setPostData((prevState) => ({...prevState, loyalty_earned: loyalty_earned, loyalty_redem: 0, balance_points:  billPoints.defaultPoint + loyalty_earned,}));
//   //     }
//   //   }
//   // }

//   // const handleChange = (newValue) => {
//   //   console.log(redeemedPonits, "Enna ithu", thisBill, "Loyalty earned", billPoints.defaultPoint, "Default point" );
//   //   let chandru = billPoints.defaultPoint + thisBill;
//   //   // setBillPoints(prev=>({...prev, total : new_bal_points}))
//   //   console.log(chandru);
//   //   if (/^\d*\.?\d*$/.test(newValue)) {
//   //     if (newValue < redeemedPonits) {
//   //       console.log(chandru - newValue, "vanthudu, fourth")
//   //       setPoints(Math.round(newValue));
//   //       setBillPoints((prev) => ({ ...prev, total: chandru - newValue }));
//   //       setPostData((prevState) => ({
//   //         ...prevState,
//   //         loyalty_redem: Number(newValue).toFixed(0),
//   //         balance_points: chandru - newValue,
//   //       }));
//   //     } else {
//   //       setPoints(Math.round(redeemedPonits));
//   //       setBillPoints((prev) => ({ ...prev, total: chandru - redeemedPonits }));
//   //     }
//   //   }
//   // };
//   function handleRedeem() {
//     if (postData.mobile !== "" && postData.mobile.length === 10 && op) {
//       const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));

//       if (netTotal >= r_amt) {
//         const total_reward_points = parseFloat(billPoints.defaultPoint).toFixed(2);
//         // const total_reward_points = parseFloat(billPoints.defaultPoint + loyalty_earned).toFixed(0);
//         const redemed_value = total_reward_points * (r_points / 100);
//         const new_bal_points = total_reward_points - redemed_value;

//         setReward(billPoints.defaultPoint + loyalty_earned);
//         console.log(loyalty_earned, "loyal_earned", "total_reward_points :", total_reward_points, "Reward :", billPoints.defaultPoint + loyalty_earned, "new_bal_points :", new_bal_points, "redeem :", redemed_value);

//         setRedeemedPoints(redemed_value);
//         setThisBill(loyalty_earned);  // Update the thisBill state here
//         setBillPoints((prev) => ({ ...prev, total: new_bal_points }));

//         if (redemed_value > netTotal) {
//           setPoints(Math.round(netTotal * (r_points / 100)));
//           setPostData((prevState) => ({
//             ...prevState,
//             loyalty_earned: loyalty_earned,
//             loyalty_redem: netTotal * (r_points / 100),
//             balance_points: parseFloat(new_bal_points).toFixed(0),
//             // balance_points: parseFloat(new_bal_points).toFixed(0),
//           }));
//         } else {
//           setRedeemedPoints(redemed_value);
//           setPoints(Math.round(redemed_value).toFixed(0));
//           setPostData((prevState) => ({
//             ...prevState,
//             loyalty_earned: loyalty_earned,
//             loyalty_redem: Number(redemed_value).toFixed(0),
//             balance_points: parseFloat(new_bal_points + loyalty_earned).toFixed(0),
//             // balance_points: parseFloat(total_reward_points).toFixed(0),

//           }));
//         }
//       } else {
//         setPoints(0);
//         setBillPoints((prev) => ({ ...prev, total: 0 }));
//         setThisBill(0);  // Ensure thisBill is reset when no redemption is possible
//       }
//     } else if (postData.mobile.length === 10 && member) {
//       const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));
//       console.log(postData.balance_points, billPoints.defaultPoint + loyalty_earned, "Enna ithu", billPoints.defaultPoint, loyalty_earned);
//       console.log(netTotal,billPoints.defaultPoint,l_amt,l_points,"netTotal");

//       setPostData((prevState) => ({
//         ...prevState,
//         balance_points: billPoints.defaultPoint,
//         // balance_points: billPoints.defaultPoint + loyalty_earned,

//       }));

//       setThisBill(loyalty_earned);  // Ensure thisBill is updated when mobile is entered
//     } else {
//       setPoints(0);
//       setPostData((prevState) => ({ ...prevState, loyalty_earned: 0, loyalty_redem: 0 }));
//       console.log('vara kudathu!', op);
//     }
//   }
//   console.log(r_points,points,"r_points");

//   function handleNewRedeem() {
//     if (postData.mobile.length === 10) {
//       const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));

//       if (netTotal >= r_amt) {
//         const total_reward_points = parseFloat(billPoints.defaultPoint + loyalty_earned).toFixed(0);
//         const redemed_value = total_reward_points * (r_points / 100);
//         const new_bal_points = total_reward_points - redemed_value;

//         setReward(billPoints.defaultPoint + loyalty_earned);
//         console.log('Yaar ivan', loyalty_earned, "loyal_earned", "total_reward_points :", total_reward_points, "Reward :", billPoints.defaultPoint + loyalty_earned, "new_bal_points :", new_bal_points, "redeem :", redemed_value, "third");

//         setPostData((prevState) => ({
//           ...prevState,
//           loyalty_earned: loyalty_earned,
//           loyalty_redem: 0,
//           balance_points: billPoints.defaultPoint + loyalty_earned,
//         }));
//         setThisBill(loyalty_earned);  // Update thisBill when mobile is entered
//       }
//     }
//   }
//   console.log(billPoints,thisBill,"billPoints");

//   const handleChange = (newValue) => {

//     let chandru = billPoints.defaultPoint + thisBill;

//     if (/^\d*\.?\d*$/.test(newValue)) {
//       if (newValue < redeemedPonits) {
//         setPoints(Math.round(newValue));
//         setBillPoints((prev) => ({ ...prev, total: chandru - newValue }));
//         setPostData((prevState) => ({
//           ...prevState,
//           loyalty_redem: Number(newValue).toFixed(0),
//           balance_points: chandru - newValue,
//         }));
//       } else {
//         setPoints(Math.round(redeemedPonits));
//         setBillPoints((prev) => ({ ...prev, total: chandru - redeemedPonits }));
//       }
//     }
//   };
//   console.log(points,"redeemedPonits");

//   function modeCheck(mode) {
//     console.log(mode, 'What is mode?', netTotal, "CAsh Amount 2")
//     if (mode === "cash") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: "0",
//         cash_amount: netTotal ,
//         upi_amount: "0",
//       }));
//     } else if (mode === "card") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: netTotal  ,
//         cash_amount: "0",
//         upi_amount: "0",
//       }));
//     } else if (mode === "upi") {
//       setPostData((prev) => ({
//         ...prev,
//         card_amount: "0",
//         cash_amount: "0",
//         upi_amount: netTotal ,
//       }));
//     }
//   }
//   console.log(postData)
//   const handleLessAmountChange = (newValue) => {
//     // Convert the input value to a number
//     const numericValue = parseInt(newValue, 10);
//     // numericValue >= 0 &&
//     // Check if the numeric value is between 0 and 9
//     if (numericValue < 10) {
//       console.log(newValue);
//       setLessAmount(newValue);
//     } else {
//       // dispatch(setSnackbar(true , 'error' , 'Please enter single digit amount'))
//       setLessAmount(0);
//     }
//   };
//   const BillNO = docNameDefault.replace("_", "-")
//     .replace("_", "-")
//     .replace("_", "-");
//   const currentDate = moment().format("DD-MM-YYYY-HH-mm-ss");
//   // console.log(currentDate)
//   // console.log(`${BillNO}${currentDate}`)
//   const getMerchantID = () => {
//     axios
//       .get(`/v1/transaction_provider/${outlet_id}`)
//       .then((res) => {
//         // console.log(res.data[0])
//         const providerData = res.data[0];
//         setMerchantId(providerData.merchant_id);
//         setUrl(providerData.url);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
//   const getPaymentType = () => {
//     axios
//       .get(`/v1/pay_type_master`)
//       .then((res) => {
//         // console.log(res.data)
//         const activePayTypes = res.data.filter((item) => item.is_active);
//         setpayType(activePayTypes);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
//   // console.log(merchantId)
//   // console.log(url)
//   // console.log(payType)
//   const payTypeApi = (e) => {
//     // console.log(e)
//     if (e.pay_type_key == "1") {
//       // console.log('Link API')
//       handleLink();
//     } else if (e.pay_type_key == "2") {
//       // console.log('QR Api')
//       handleQRCode();
//     } else {
//       // console.log('ISQR Api')
//       // handleSubmit()
//       handleApiData();
//     }
//   };
//   const handleLink = () => {
//     // setMerchantId(id)
//     // console.log("handle link")
//     setMergedBillDate(`${BillNO}${currentDate}`);
//     const linkDataPay = {
//       transactionId: `${BillNO}${currentDate}`,
//       merchantOrderId: `${BillNO}`,
//       amount:
//         paymentDetails.upi > 0
//           ? paymentDetails.upi * 100
//           : parseInt(netTotal * 100),
//       instrumentType: "MOBILE",
//       instrumentReference: postData.mobile,
//       message: "collect for XXX order",
//       email: "test@gmail.com",
//       expiresIn: 1800,
//       shortName: "test",
//       storeId: outlet_id,
//       terminalId: outlet_id,
//     };
//     console.log(linkDataPay);
//     axios
//       .post(`${url}/payments/${merchantId}`, linkDataPay)
//       .then((res) => {
//         // console.log(res)
//         // getStatusPayment()
//         setOpen(false);
//         setLinkOpen(true);
//         setShouldPoll(true);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
//   const handleQRCode = () => {
//     // setMerchantId(id)
//     // console.log(id)
//     setMergedBillDate(`${BillNO}${currentDate}`);
//     console.log("handle QR");
//     const qrCode = {
//       transactionId: `${BillNO}${currentDate}`,
//       merchantOrderId: `${BillNO}`,
//       amount:
//         paymentDetails.upi > 0
//           ? paymentDetails.upi * 100
//           : parseInt(netTotal * 100),
//       storeId: outlet_id,
//       terminalId: outlet_id,
//       expiresIn: 1800,
//     };
//     console.log(qrCode);
//     console.log(merchantId);
//     axios
//       .post(`${url}/static/qrcode/generate/${merchantId}`, qrCode)
//       .then((res) => {
//         console.log(res.data.data.qrString);
//         setQrCode(res.data.data.qrString);
//         setQrOpen(true);
//         setOpen(false);
//         setShouldPoll(true);
//         // }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
//   // console.log(merchantId)
//   // console.log(phonePayHistory)
//   console.log(postData,"postdata")
//   const getStatusPayment = () => {
//     axios
//       .get(`${url}/payment/status/${merchantId}/${mergedBillDate}`)
//       .then((res) => {
//         // const apiResposeData = res.data
//         // console.log(apiResposeData)
//         // console.log(responseData)
//         const paymentState = res.data.data.paymentState;
//         if (paymentState) {
//           setPaymentState(paymentState);
//           setOpen(false);
//           if (paymentState === "PENDING") {
//             if (qrCode) {
//               setLinkOpen(false);
//             } else {
//               setLinkOpen(true);
//             }
//             setDialogOpen(false);
//             setShouldPoll(true);
//           } else if (paymentState === "FAILED") {
//             setResponseData(res.data);
//             setDialogContent("Your payment is failed. Please try again.");
//             setDialogOpen(true);
//             setShouldPoll(false);
//             setQrOpen(false);
//             setTimeout(() => {
//               handleHistoryData(res.data);
//             }, 1000);
//           } else if (paymentState === "CANCELLED") {
//             console.log(res.data);
//             setShouldPoll(false);
//             setTimeout(() => {
//               handleHistoryData(res.data);
//             }, 1000);
//           } else if (paymentState === "COMPLETED") {
//             setResponseData(res.data);
//             setDialogContent("Your payment is successful.");
//             setDialogOpen(true);
//             setShouldPoll(false);
//             setQrOpen(false);
//             setTimeout(() => {
//               handleHistoryData(res.data);
//             }, 1000);
//             // setTimeout(() => {
//             //   handleApiData()
//             // },5000)
//           }
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching payment status:", err);
//         setIsLoader(false);
//       });
//   };
//   // console.log(responseData)
//   const handleHistoryData = (resData) => {
//     console.log(resData);
//     // console.log(responseData)

//     setPhonePayHistory((prev) => ({
//       ...prev,
//       response_json: {
//         data: resData,
//       },
//     }));
//     console.log(phonePayHistory);
//     setPhonePayHistory((prevPhonePayHistory) => {
//       axios
//         .post(`/v1/phone_pay_history_log`, prevPhonePayHistory)
//         .then((res) => {
//           console.log(res);
//         })
//         .catch((err) => {
//           console.log(err);
//         });

//       // Returning the updated state
//       return prevPhonePayHistory;
//     });
//   };
//   const handleCancelAll = () => {
//     setDialogOpen(false);
//     setShouldPoll(false);
//     setQrOpen(false);
//     setLinkOpen(false);
//     setOpen(false);
//   };
//   useEffect(() => {
//     if (dialogOpen) {
//       setCountdown(3); // reset the countdown when the dialog opens

//       const intervalId = setInterval(() => {
//         setCountdown((prev) => {
//           if (prev === 1) {
//             clearInterval(intervalId);
//             if (paymentState === "COMPLETED") {
//               handleApiData();
//               handleCancelAll();
//             } else {
//               handleCancelAll();
//             }
//           }
//           return prev - 1;
//         });
//       }, 1000);

//       return () => {
//         clearInterval(intervalId);
//       };
//     }
//   }, [dialogOpen]);
//   useEffect(() => {
//     if (shouldPoll) {
//       const intervalId = setInterval(getStatusPayment, 1000);
//       return () => clearInterval(intervalId);
//     }
//   }, [shouldPoll]);
//   const HandleLinkCancel = () => {
//     setLinkOpen(false);
//     setOpen(false);
//     setShouldPoll(false);
//     axios
//       .post(`${url}/cancel/payment/${merchantId}/${mergedBillDate}`)
//       .then((res) => {
//         // console.log(res)
//         setCancelStatus(true);
//         // dispatch(setSnackbar(true , "success" , "Your link payment cancel successfully!"))
//         getStatusPayment();
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
//   const handleQrCancel = () => {
//     setQrOpen(false);
//     setOpen(false);
//     setShouldPoll(false);
//     axios
//       .post(`${url}/cancel/payment/${merchantId}/${mergedBillDate}`)
//       .then((res) => {
//         console.log(res);
//         setCancelStatus(true);
//         // dispatch(setSnackbar(true , "success" , "Your QR Code payment cancel successfully!"))
//         getStatusPayment();
//         // handleHistoryData()
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     // if(reward!=='0'){
//     axios
//       .get("v1/loyalty/info/1")
//       .then((res) => {
//         // console.log(res.data)
//         const value = res.data;
//         setLAmt(value.loyalty_amount);
//         setLPoints(value.loyalty_points);
//         setRAmt(value.redemption_amount);
//         setRPoints(value.redemption_percentage);
//         // setReward(prev => parseFloat(prev) + totalAmt * value.loyalty_points / value.loyalty_amount)
//       })
//       .catch((err) => {
//         console.log(err.response);
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//     // }
//   }, []);
//   // useEffect(() => {
//   //   if (merchantId) {
//   //     getStatusPayment(merchantId);
//   //   }
//   // }, [merchantId]);
//   // useEffect(()=>{
//   //   setPostData((prevState)=>({...prevState,  loyalty_redem : 0, }))
//   // },[points])

//   useEffect(() => {
//     handleRedeem();
//   }, [op, totalAmt, postData.mobile]);
// console.log(postData,"postData");

//   useEffect(() => {
//     if (!op) {
//       handleNewRedeem();
//     }
//   }, [member, totalAmt, billPoints]);
//   useEffect(() => {
//     setPostData((prevState) => ({
//       ...prevState,
//       transaction_id: mergedBillDate == "" ? "" : mergedBillDate,
//       transaction_provider: 1,
//       transaction_type: qrCode ? 2 : linkOpen ? 1 : 3,
//     }));
//   }, [data, mergedBillDate, qrCode, linkOpen]);
//   useEffect(() => {
//     setPostData((prev) => ({
//       ...prev,
//       less_amount: parseFloat(lessAmount).toFixed(0),
//     }));
//   }, [lessAmount]);

//   useEffect(() => {
//     modeCheck(selectedMode);
//     setPostData((prevState) => ({
//       ...prevState,
//       amount: Math.round(subNetTotal),
//       // amount: Math.round(netTotal),
//       cess_amt: cessAmt,
//       subtotal_amount: parseFloat(totalAmt).toFixed(0),
//       gst_amt: gstAmt,
//       roff: parseFloat(Math.round(netTotal).toFixed(0) - netTotal),
//     }));
//   }, [data, lessAmount , points, selectedMode]);
// console.log(postData,"postdatacheck");

//   console.log(paymentDetails.cash,'Ithan cash amount 3')
//   useEffect(() => {
//     setPostData((prev) => ({
//       ...prev,
//       card_amount: paymentDetails.card,
//       cash_amount: paymentDetails.cash,
//       upi_amount: paymentDetails.upi,
//     }));
//   }, [paymentDetails]);
//   useEffect(() => {
//     setPhonePayHistory((prev) => ({
//       ...prev,
//       docno: BillNO,
//       transaction_id: mergedBillDate,
//       merchant_order_id: BillNO,
//       phone_no: postData.mobile,
//       request_json: { data: postData },
//     }));
//   }, [BillNO, postData]);

//   // useEffect(() => {
//   //   if (responseData && Object.keys(responseData).length > 0) {
//   //     setPhonePayHistory(prevState => ({
//   //       ...prevState,
//   //       response_json: {
//   //         data: responseData
//   //       }
//   //     }));
//   //   }
//   // }, [responseData]);
//   useEffect(() => {
//     setPostData(prevData => ({
//       ...prevData,
//       discount_amount: discountamt, // Set the calculated discount amount here
//     }));
//   }, [discountamt, setPostData]); // Add dependency on discountamt
//   useEffect(() => {
//     getMerchantID();
//     getPaymentType();
//   }, []);
//   // console.log(gstAmt,cessAmt,parseFloat(netTotal - Math.round(netTotal)).toFixed(0), netTotal - Math.round(netTotal))
//   return (
//     <Fragment>
//       <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }} >Total</Typography>
//       <div className="flex p-1">
//         <Typography textAlign="right"
//         sx={{
//             paddingRight: 0.4,
//             fontWeight: 600,
//             fontSize: 36,
//             width: "100%",
//           }}
//         >
//           {/* {Math.round(netTotal -discountamt).toFixed(0)} */}
//           {netTotal}
//         </Typography>
//       </div>
//       <div className="my-2">
//         <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }} >Summary{" "}
//         </Typography>
//         {/* <Design title="Sub Total" value={totalAmt} /> */}

//         <p style={{ display: 'flex', justifyContent: 'space-between' ,marginBottom: 10}}>
//   <strong>Sub Total</strong>
//   <span style={{fontSize:20}}><strong>{totalAmt.toFixed(2)}</strong></span>
// </p>
//         {/* <Design title="GST Amt" value={gstAmt} /> */}

//         <p style={{ display: 'flex', justifyContent: 'space-between' }}>
//   <strong>GST Amt</strong>
//   <span style={{fontSize:20}}><strong>{gstAmt.toFixed(2)}</strong></span>
// </p>

//         <Design title="Discount Amt" value={discountamt} />
//         {/* <Design title="Cess" value={cessAmt}/> */}
//         {enableRedeem ? (
//           <div className="flex items-center">
//             <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
//               Redeem Points
//             </Typography>
//             <TextField
//               size="small"
//               value={points}
//               onChange={(e) => handleChange(e.target.value)}
//               inputProps={{
//                 inputMode: "numeric",
//                 pattern: "[0-9]*",
//                 style: {
//                   textAlign: "right",
//                   width: "100px",
//                   fontWeight: "600",
//                 },
//               }}
//             />
//           </div>
//         ) : (
//           <Design title="Redeem Points" value={0} />
//         )}
//         {/* <Design title="Redeem Points" value={points}/> */}

//         <Design
//           title="Round Off"
//           value={Math.round(netTotal).toFixed(0) - netTotal}
//         />
//         <div className="flex items-center">
//           <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
//             Less Amount
//           </Typography>
//           <TextField
//             size="small"
//             autoComplete="off"
//             value={lessAmount}
//             onChange={(e) => handleLessAmountChange(e.target.value)}
//             inputProps={{
//               inputMode: "numeric",
//               pattern: "[0-9]*",
//               style: { textAlign: "right", width: "100px", fontWeight: "600" },
//             }}
//           />
//         </div>
//         {
//           returnAmnt !== "" && (
//             <Design title="Return Amount" value={returnAmnt} />
//           )
//           //   <div className="flex items-center">
//           //   <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
//           //     Return Amount
//           //   </Typography>
//           //   <TextField size="small" value={netTotal > returnAmnt ? returnAmnt : netTotal  } onChange={(e) => handleChangeAmnt(e.target.value)} inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', style: { textAlign: 'right',width:"80px" } }} autoComplete='off'/>
//           // </div>
//         }
//         <Design title="Net Total" value={Math.round(subNetTotal)} />
//       </div>
//       <Stack>
//         {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="outlined" onClick={()=>setData([])}>Delete</Button>
//           <Button size="small" sx={{margin:1}} startIcon={<Print/>} variant="outlined" onClick={()=>handlePrint()}>Print</Button> */}
//         <Button
//           size="small"
//           variant="contained"
//           sx={{ margin: 1, backgroundColor: "blueviolet !important" }}
//           startIcon={<NoteAdd />}
//           onClick={() => window.location.reload()}
//         >
//           New
//         </Button>
//         {/* <Button
//           size="small"
//           variant="contained"
//           sx={{ margin: 1, backgroundColor: "green !important" }}
//           startIcon={<Save />}
//           onClick={handleSubmit}
//         >
//           Save
//         </Button> */}
//         <Button
//   size="small"
//   variant="contained"
//   sx={{ margin: 1, backgroundColor: "green !important" }}
//   startIcon={<Save />}
//   onClick={handleSubmit}
//   // disabled={isSubmitting} // Disable button while submitting
// >
//   Save
// </Button>
//         <Button
//           size="small"
//           variant="contained"
//           sx={{ margin: 1, backgroundColor: "red !important" }}
//           startIcon={<ExitToApp />}
//           onClick={handleExit}
//         >
//           Exit
//         </Button>
//       </Stack>
//       {/* <Backdrop open={open} sx={{zIndex : 1150}}>
//             <Grid sx={{backgroundColor:'white', position : 'absolute', zIndex:1150, top:0,left : 0,  padding: 1}}>
//           <PrintBill data={open} close={setOpen}/>
//           </Grid>
//           </Backdrop> */}
//       <Dialog open={openDialog}>
//         <DialogTitle>Mixed Payment Details</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             name="cash"
//             label="Cash Amount"
//             fullWidth
//             value={paymentDetails.cash}
//             // onChange={handleInputChange}
//           />
//           <TextField
//             margin="dense"
//             name="card"
//             label="Card Amount"
//             fullWidth
//             value={paymentDetails.card}
//             onChange={handleInputChange}
//           />

//           <TextField
//             margin="dense"
//             name="upi"
//             label="UPI Amount"
//             fullWidth
//             value={paymentDetails.upi}
//             onChange={handleInputChange}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button variant="outlined" onClick={hanldleDialog}>
//             CANCEL
//           </Button>
//           <Button variant="contained" onClick={handleMixedData}>
//             SUBMIT
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <DialogCancel
//         onClickCancel={onClickCancel}
//         onClickExit={onClickExit}
//         dialogClose={dialogClose}
//         setDialogClose={setDialogClose}
//       />
//       <Dialog open={open}>
//         <DialogTitle
//           sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
//         >
//           UPI Pay Details
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             width: "600px",
//             height: "150px",
//             padding: 3,
//           }}
//         >
//           <Grid container spacing={2} justifyContent="center">
//             {_.map(payType, (val, idx) => {
//               const style = buttonStyles[idx % buttonStyles.length];
//               return (
//                 <Grid item key={idx}>
//                   <Grid
//                     // variant="outlined"
//                     onClick={() => payTypeApi(val)}
//                     sx={{
//                       marginInline: "10px",
//                       padding: "10px",
//                       cursor: "pointer",
//                       border: `2px solid ${style.borderColor}`,
//                       borderRadius: "5px",
//                       fontWeight: "bold",
//                       color: style.color,
//                       "&:hover": {
//                         backgroundColor: style.hoverColor,
//                         borderColor: style.borderColor,
//                       },
//                     }}
//                   >
//                     {val.pay_type_name}
//                   </Grid>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         </DialogContent>
//         {/* <Button variant='outlined' onClick={() => handleLink('BLUEKODETESTUAT')}>Link</Button>
//             <Button variant='outlined' sx={{marginInlineStart:"10px"}} onClick={() => handleQRCode('BLUEKODEDQRUAT')}>Show QR Code</Button>
//             <Button variant='outlined' sx={{marginInlineStart:"10px"}} onClick={handleSubmit}>Direct Payment</Button> */}
//         {/* </DialogContent> */}
//         <DialogActions>
//           <Button variant="outlined" onClick={handlePaymentClose}>
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog open={dialogOpen}>
//         <DialogTitle
//           sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
//         >
//           Payment Status
//         </DialogTitle>
//         <DialogContent sx={{ width: "400px", margin: "0 auto" }}>
//           <img
//             src={paymentState === "COMPLETED" ? success : failed}
//             style={{ width: "150px", margin: "0 auto" }}
//           />
//           <DialogContentText sx={{ textAlign: "center" }}>
//             {dialogContent}
//           </DialogContentText>
//           <DialogContentText sx={{ textAlign: "center", fontWeight: "bold" }}>
//             Please wait {countdown.toFixed(1)} seconds...
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="outlined"
//             onClick={
//               paymentState === "COMPLETED" ? handleApiData : handleCancelAll
//             }
//             color="primary"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog open={linkOpen}>
//         <DialogTitle
//           sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
//         >
//           Check Payment link in your Mobile
//         </DialogTitle>
//         <BarLoader color="#BA68C8" width={350} />
//         <DialogActions>
//           <Button variant="outlined" onClick={HandleLinkCancel}>
//             Cancel Payment
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog open={qrOpen}>
//         <DialogTitle
//           sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
//         >
//           Scan QR to pay
//         </DialogTitle>
//         <DialogContent
//           sx={{
//             textAlign: "center",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <QRCode value={qrCode} />
//           <Grid sx={{ marginBlock: "20px" }}></Grid>
//           <BarLoader color="#BA68C8" width={350} />
//         </DialogContent>
//         <DialogActions>
//           <Button variant="outlined" onClick={handleQrCancel}>
//             Cancel Payment
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Dialog open={cancelStatus}>
//         <DialogTitle
//           sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
//         >
//           Payment Cancel
//         </DialogTitle>
//         <DialogContent sx={{ width: "400px", margin: "0 auto" }}>
//           <img src={failed} style={{ width: "150px", margin: "0 auto" }} />
//           <DialogContentText sx={{ textAlign: "center" }}>
//             Your payment cancel successfully!
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="outlined"
//             onClick={() => {
//               setCancelStatus(false);
//               setOpen(true);
//               setShouldPoll(false);
//               setQrCode("");
//             }}
//           >
//             Retry Payment
//           </Button>
//           <Button
//             variant="outlined"
//             onClick={() => setCancelStatus(false)}
//             color="primary"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//       <Loader isLoader={isLoader} />
//     </Fragment>
//   );
// };

// export default memo(CustomerInfo);

// testing referral program
import { ExitToApp, NoteAdd, Save } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, {
  Fragment,
  memo,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import QRCode from "react-qr-code";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BarLoader } from "react-spinners";
import failed from "../../../../../assets/images/failed.png";
import success from "../../../../../assets/images/success.gif";
import {
  onPressButton,
  setThermalData,
} from "../../../../../components/hooks/printPdf/thermalData";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import Loader from "../../../../../components/loader/loader";
import DialogCancel from "../../../../../components/utils/dialogCancel/dialogCancel";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const CustomerInfo = forwardRef(
  (
    {
      data,
      docName,
      postData,
      setPostData,
      docNameDefault,
      thisBill,
      setThisBill,
      setBillPoints,
      billPoints,
      setReward,
      op,
      setReturnAmnt,
      returnAmnt,
      enableRedeem,
      member,
      selectedMode,
      currentTempId,
      disc1,
    },
    ref,
  ) => {
    const [open, setOpen] = useState(false);
    const [l_points, setLPoints] = useState("");
    const [l_amt, setLAmt] = useState("");
    const [r_points, setRPoints] = useState("");
    const [r_amt, setRAmt] = useState(0);
    const [points, setPoints] = useState(0.0);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogClose, setDialogClose] = useState(false);
    const [isLoader, setIsLoader] = useState(false); //loader
    const outlet_id = localStorage.getItem("outlet_id");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [paymentState, setPaymentState] = useState(null);
    const [shouldPoll, setShouldPoll] = useState(false);
    const [dialogContent, setDialogContent] = useState("");
    const [merchantId, setMerchantId] = useState("");
    const [url, setUrl] = useState("");
    const [qrCode, setQrCode] = useState("");
    const [qrOpen, setQrOpen] = useState(false);
    const [linkOpen, setLinkOpen] = useState(false);
    const [mergedBillDate, setMergedBillDate] = useState("");
    const [cancelStatus, setCancelStatus] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [payType, setpayType] = useState([]);
    const [redeemedPonits, setRedeemedPoints] = useState(0.0);
    const [countdown, setCountdown] = useState(3);
    const [lessAmount, setLessAmount] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSavingDraft, setIsSavingDraft] = useState(false);
    const [pendingId, setPendingId] = useState(null);
    const [phonePayHistory, setPhonePayHistory] = useState({
      docno: "",
      transaction_date: moment().format("YYYY-MM-DD"),
      merchant_order_id: "",
      transaction_id: "",
      response_json: {
        data: "data response",
      },
      request_json: {
        data: "data request",
      },
      phone_no: "",
    });
    const [paymentDetails, setPaymentDetails] = useState({
      card: "0",
      cash: "0",
      upi: "0",
    });
    const [openEDCStatus, setOpenEDCStatus] = useState(false);
    const [activeEdcTxnId, setActiveEdcTxnId] = useState(null);
    // const [edcPaymentOption, setEdcPaymentOption] = useState(null);
    // const [edcPaymentOption, setEdcPaymentOption] = useState("CREDIT_CARD");
    const [edcPaymentOption, setEdcPaymentOption] = useState(null);
    const [edcPollingInterval, setEdcPollingInterval] = useState(null);
    const [edcStatus, setEdcStatus] = useState(null);
    const [edcUIState, setEdcUIState] = useState("INIT");
    const [isEdcPayTriggered, setIsEdcPayTriggered] = useState(false);
    const [edcLoadingText, setEdcLoadingText] = useState("");
    // const EDC_MERCHANT_ID = "BLUEKODEUAT"; // ✅ Fixed
    // const EDC_TERMINAL_ID = "testterminal1";
    const [provider, setProvider] = useState(null);
    const [isEdcSuccess, setIsEdcSuccess] = useState(false);
    const [isEdcCancelled, setIsEdcCancelled] = useState(false);

    const onClickCancel = () => {
      setDialogClose(false);
    };
    const onClickExit = () => {
      navigate("/");
    };
    // console.log(paymentDetails)
    const handleExit = () => {
      setDialogClose(true);
    };
    // console.log(phonePayHistory)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let totalAmt = 0;
    totalAmt += data.reduce(
      (accumulator, item) => accumulator + parseFloat(item.totalAmt),
      0,
    );

    let gstAmt = 0;
    gstAmt += data.reduce(
      (accumulator, item) => accumulator + parseFloat(item.gstAmt),
      0,
    );

    // let discountamt = 0;
    // discountamt += data.reduce(
    //   (accumulator, item) => accumulator + parseFloat(item.discountamt),
    //   0
    // );
    let discountamt = data.reduce(
      // (accumulator, item) => accumulator + (parseFloat(item.rate1 || 0) + parseFloat(item.gstAmt || 0) - parseFloat(item.disc1))* item.qty,
      // 0
      (accumulator, item) =>
        accumulator +
        ((parseFloat(item.disc1 || 0) * parseFloat(item.mrp1 || 0)) / 100) *
          item.qty,
      // (accumulator, item) => accumulator + (parseFloat(item.disc1 || 0) * parseFloat(item.rate1 || 0)  / 100)* item.qty,
      0,
    );
    console.log(totalAmt, "datadatadata");

    // let discountamt = data.reduce((accumulator, item) => {
    //   // Only calculate discount if disc1 is not 100%
    //   if (parseFloat(item.disc1 || 0) === 100) {
    //     return accumulator; // Skip adding discount if it's 100%
    //   }

    //   // Calculate the discount for non-100% disc1
    //   return accumulator + (parseFloat(item.disc1 || 0) * parseFloat(item.rate1 || 0) / 100) * item.qty;
    // }, 0);

    // let discountamt = parseFloat(disc1 + gstAmt ).toFixed(0);
    // dis_amt = parseFloat(
    //   ((rate1 - (rate1 * (100 - disc1)) / 100) * qty)
    // ).toFixed(0);

    let cessAmt = 0;
    cessAmt += data.reduce(
      (accumulator, item) => accumulator + parseFloat(item.cessAmt),
      0,
    );
    let netTotal = 0;

    if (enableRedeem) {
      netTotal = parseFloat(
        totalAmt + gstAmt - points - lessAmount - returnAmnt,
      ).toFixed(0);
    } else {
      netTotal = parseFloat(
        totalAmt + gstAmt - lessAmount - returnAmnt,
      ).toFixed(0);
    }
    console.log(points, "enableRedeem");

    // let subNetTotal = parseFloat(totalAmt + gstAmt - lessAmount).toFixed(0);
    let subNetTotal = parseFloat(totalAmt + gstAmt).toFixed(0);
    // let subNetTotal = parseFloat(totalAmt + gstAmt - discountamt).toFixed(0);

    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Million", "Billion", "Trillion"];
    const buttonStyles = [
      { borderColor: "blue", color: "blue", hoverColor: "#e0f7fa" },
      { borderColor: "green", color: "green", hoverColor: "#e8f5e9" },
      { borderColor: "violet", color: "violet", hoverColor: "#ee82ee26" },
      { borderColor: "#FF6B35", color: "#FF6B35", hoverColor: "#ffe5d9" },
    ];
    const convertNumber = (num) => {
      if (num === 0) return "Zero";

      let words = "";
      for (let i = 0; num > 0; i++) {
        if (num % 1000 !== 0) {
          words =
            convertHundreds(num % 1000) + " " + thousands[i] + " " + words;
        }
        num = Math.floor(num / 1000);
      }
      return words.trim();
    };
    // console.log(billPoints.thisBill)
    const convertHundreds = (num) => {
      if (num >= 100) {
        return (
          units[Math.floor(num / 100)] + " Hundred " + convertTens(num % 100)
        );
      } else {
        return convertTens(num);
      }
    };

    const convertTens = (num) => {
      if (num < 10) return units[num];
      else if (num < 20) return teens[num - 10];
      else return tens[Math.floor(num / 10)] + " " + units[num % 10];
    };

    const Design = ({ title, value }) => (
      <div className="flex items-center">
        <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
          {title}
        </Typography>
        <Typography
          variant="h6"
          textAlign="right"
          sx={{ fontWeight: 600, width: "100%", padding: 0.5 }}
        >
          {parseFloat(value).toFixed(0)}
        </Typography>
      </div>
    );

    function hanldleDialog() {
      setOpenDialog(false);
      setPaymentDetails((prev) => ({
        ...prev,
        card: "0",
        cash: "0",
        upi: "0",
      }));
    }
    // function handleApiData() {
    //   console.log(postData, "postdata");
    //   setIsLoader(true);
    //   axios
    //     .post(`/v1/outlet_sales_master`, postData)
    //     .then((res) => {
    //       fetchBill(res.data.docno);
    //       setIsLoader(false);
    //     })
    //     .catch((err) => {
    //       // console.log(err);
    //       setIsLoader(false);
    //       dispatch(
    //         setSnackbar(true, "error", err.response.data.errors[0].message)
    //       );
    //     });
    // }
    // function handleApiData() {
    //   console.log(postData, "postdata");
    //   setIsLoader(true);
    //   setIsSubmitting(true);
    //   axios
    //     .post(`/v1/outlet_sales_master`, postData)
    //     .then((res) => {
    //       fetchBill(res.data.docno);
    //       setIsLoader(false);
    //       setIsSubmitting(false);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setIsLoader(false);
    //       setIsSubmitting(false);
    //       dispatch(
    //         setSnackbar(true, "error", err.response.data.errors[0].message)
    //       );
    //     });
    // }
    // new logic for pending bills
    // function handleApiData() {
    //   console.log(postData, "postdata");
    //   setIsLoader(true);
    //   setIsSubmitting(true);

    //   axios
    //     .post(`/v1/outlet_sales_master`, postData)
    //     .then((res) => {
    //       fetchBill(res.data.docno);

    //       // if (currentTempId) {
    //       //   axios
    //       //     .delete(
    //       //       `v1/outlet_sales_pending_bill/1/${outlet_id}/${currentTempId}`
    //       //     )
    //       //     .catch(() => {});
    //       // }

    //       setIsLoader(false);
    //       setIsSubmitting(false);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       setIsLoader(false);
    //       setIsSubmitting(false);
    //       dispatch(
    //         setSnackbar(true, "error", err.response.data.errors[0].message)
    //       );
    //     });
    // }
    // 20-01-26
    function handleApiData(payload = postData) {
      console.log(payload, "FINAL PAYLOAD"); // ✅ correct log

      setIsLoader(true);
      setIsSubmitting(true);

      axios
        .post(`/v1/outlet_sales_master`, payload)
        .then((res) => {
          fetchBill(res.data.docno);

          // OPTIONAL: remove pending bill after success
          // if (currentTempId) {
          //   axios
          //     .delete(
          //       `/v1/outlet_sales_pending_bill/1/${outlet_id}/${currentTempId}`
          //     )
          //     .catch(() => {});
          // }
        })
        .catch((err) => {
          console.error("Save bill failed", err);

          dispatch(
            setSnackbar(
              true,
              "error",
              err.response?.data?.errors?.[0]?.message || "Save failed",
            ),
          );
        })
        .finally(() => {
          setIsLoader(false);
          setIsSubmitting(false);
        });
    }

    function fetchBill(e) {
      axios
        .post(`/v1/outlet_sales_master/getall`, { docno: e })
        .then((res) => {
          // console.log(res)
          dispatch(
            setThermalData({
              tableData: tableData,
              TotalData: TotalData,
              companyInfo: res.data,
              totalText: convertNumber(Math.round(netTotal)),
              redeemedValue: enableRedeem ? points : 0,
              lessAmount: lessAmount,
            }),
          );
          dispatch(onPressButton());
          const input = docName.replace(/\//g, "_");
          const name = `BillNo_${input}`;
          navigate(`/sales/${name}`);
        })
        .catch((err) => {
          // console.log(err)
          dispatch(
            setSnackbar(true, "error", err.response.data.errors[0].message),
          );
        });
    }

    // function handleMixedData() {
    //   if (paymentDetails.upi > 0) {
    //     setOpen(true);
    //     setOpenDialog(false);
    //   } else {
    //     handleApiData();
    //   }
    // }

    function handleMixedData() {
      if (isEdcCancelled && !isEdcSuccess) {
        dispatch(setSnackbar(true, "error", "Retry payment"));
        return;
      }
      const hasCard = Number(paymentDetails.card || 0) > 0;
      const hasUpi = Number(paymentDetails.upi || 0) > 0;

      if (hasCard && !hasUpi) {
        setOpenDialog(false);
        handleEDCStage(); // only card
        return;
      }

      if (hasUpi && !hasCard) {
        setOpenDialog(false);
        // setOpen(true); // only
        handleEDCStage();
        return;
      }

      if (hasCard && hasUpi) {
        handleEDCStage(); // (keep same flow, no break)
        return;
      }
      // handleApiData();
      // setOpenDialog(false);
      if (!hasCard && !hasUpi) {
        handleApiData();
        setOpenDialog(false);
      }
    }

    function handlePaymentClose() {
      setOpen(false);
      setIsSubmitting(false);
      if (paymentDetails.upi > 0) {
        setOpenDialog(true);
      }
    }
    // with QR Scan
    // function handleSubmit() {
    //   if (isSubmitting) return; // Prevent double submission
    //   setIsSubmitting(true); // Disable the button

    //   if (postData.partycode === "") {
    //     dispatch(setSnackbar(true, "error", "Please select party Name"));
    //     setIsSubmitting(false);
    //   } else if (postData.outlet_sales_details.length === 0) {
    //     dispatch(setSnackbar(true, "error", "Please fill table"));
    //     setIsSubmitting(false);
    //   } else if (postData.salesman_id === "") {
    //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
    //     setIsSubmitting(false);
    //   } else if (postData.mode === "" || postData.mode === null) {
    //     dispatch(setSnackbar(true, "error", "Select Payment mode"));
    //     setIsSubmitting(false);
    //   } else if (postData.mode === "upi") {
    //     if (postData.mobile === "") {
    //       dispatch(setSnackbar(true, "error", "Please enter the mobile Number"));
    //       setIsSubmitting(false);
    //     } else if (postData.mobile.length !== 10) {
    //       dispatch(setSnackbar(true, "error", "Please enter 10 digit mobile Number"));
    //       setIsSubmitting(false);
    //     } else {
    //       setOpen(true);
    //     }
    //   } else if (postData.mode === "mixed") {
    //     setOpenDialog(true);
    //     setPaymentDetails((prev) => ({
    //       ...prev,
    //       cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
    //       // cash: netTotal,

    //     }));

    //   } else {
    //     handleApiData();
    //   }

    //   // setTimeout(() => setIsSubmitting(false), 2000); // Re-enable button after a delay or after operation completion
    // }

    console.log(data, "salesprint1233");

    // without QR scan Link

    // function handleSubmit() {
    //   if (isSubmitting) return; // Prevent double submission

    //   if (postData.partycode === "") {
    //     dispatch(setSnackbar(true, "error", "Please select party Name"));
    //     return;
    //   }

    //   if (postData.outlet_sales_details.length === 0) {
    //     dispatch(setSnackbar(true, "error", "Please fill table"));
    //     return;
    //   }

    //   if (postData.salesman_id === "") {
    //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
    //     return;
    //   }
    //   // if (postData.party_name === "" && postData.mobile === "") {
    //   //   dispatch(setSnackbar(true, "error", "Please enter Party name"));
    //   //   return;
    //   // }
    //   // if ((postData.party_name === "" || postData.mobile === "") && !(postData.party_name === "" && postData.mobile === "")) {
    //   //   dispatch(setSnackbar(true, "error", "Please enter Party name and Mobile number"));
    //   //   return;
    //   // }
    //   if (postData.party_name === "" && postData.mobile !== "") {
    //     dispatch(setSnackbar(true, "error", "Please enter Customer name"));
    //     return;
    //   }

    //   if (postData.mobile === "" && postData.party_name !== "") {
    //     dispatch(setSnackbar(true, "error", "Please enter Mobile number"));
    //     return;
    //   }

    //   if (postData.mode === "" || postData.mode === null) {
    //     dispatch(setSnackbar(true, "error", "Select Payment mode"));
    //     return;
    //   }
    //   if (postData.channels === "" || postData.channels === null) {
    //     dispatch(setSnackbar(true, "error", "Select Channel"));
    //     return;
    //   }

    //   // if (postData.mode === "upi") {
    //   //   if (postData.mobile === "") {
    //   //     dispatch(setSnackbar(true, "error", "Please enter the mobile Number"));
    //   //     return;
    //   //   } else if (postData.mobile.length !== 10) {
    //   //     dispatch(setSnackbar(true, "error", "Please enter 10 digit mobile Number"));
    //   //     return;
    //   //   } else {
    //   //     setOpen(true); // This is UI only, no need to block with isSubmitting
    //   //     return;
    //   //   }
    //   // }

    //   if (postData.mode === "mixed") {
    //     setOpenDialog(true);
    //     setPaymentDetails((prev) => ({
    //       ...prev,
    //       cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
    //     }));
    //     return; // No need for isSubmitting
    //   }

    //   // ✅ Actual submission
    //   setIsSubmitting(true);
    //   handleApiData();
    // }

    const handleNew = () => {
      if (isSubmitting) return;
      if (postData.outlet_sales_details?.length === 0 || data.length === 0) {
        dispatch(setSnackbar(true, "error", "Please fill table data first"));
        return;
      }
      setIsSavingDraft(true);
      setIsLoader(true);
      // Prepare sales details for API
      const salesDetails = data.map((item) => ({
        docdate: moment().format("YYYY-MM-DDTHH:mm:ss"),
        outletid: parseInt(outlet_id),
        company_id: 1,
        prodid: item.prodid || item.id || 0,
        dis_per: parseFloat(item.disc1 || 0),
        dis_amt: 0,
        mrp: parseFloat(item.mrp || item.mrp1 || 0),
        rate: parseFloat(item.salerate || item.rate1 || 0),
        qty: parseFloat(item.qty || 0),
        gst_per: parseFloat(item.gst || 0),
        gst_amt: parseFloat(item.gstAmt || 0),
        cess_per: 0,
        cess_amt: parseFloat(item.cessAmt || 0),
        barcode: item.barcode || "",
        head_id: 1,
        type_id: 1,
        subcat_id: item.subcat_id || 10,
        cat_id: item.cat_id || 5,
        uom_id: 1,
        igst_per: 0,
      }));

      const tempSaveData = {
        // ✅ ALL NUMBERS properly parsed
        os_mst_id: currentTempId || pendingId || 0,
        docno: docNameDefault || `TEMP_${moment().format("YYYYMMDDHHmmss")}`,
        salesman_id: parseInt(postData.salesman_id) || 0,
        outletid: parseInt(outlet_id),
        company_id: 1,
        amount: Math.round(parseFloat(netTotal)) || 0,
        subtotal_amount: parseInt(parseFloat(totalAmt).toFixed(0)) || 0,
        gst_amt: parseInt(parseFloat(gstAmt).toFixed(0)) || 0,
        cess_amt: parseInt(parseFloat(cessAmt).toFixed(0)) || 0,
        roff:
          parseInt((Math.round(netTotal) - parseFloat(netTotal)).toFixed(0)) ||
          0,
        cash_amount:
          parseInt(postData.cash_amount || paymentDetails.cash || 0) || 0,
        card_amount:
          parseInt(postData.card_amount || paymentDetails.card || 0) || 0,
        upi_amount:
          parseInt(postData.upi_amount || paymentDetails.upi || 0) || 0,
        less_amount: parseInt(lessAmount) || 0,
        discount_amount: parseInt(discountamt) || 0,
        loyalty_earned: parseInt(postData.loyalty_earned || 0) || 0,
        loyalty_redem: parseInt(postData.loyalty_redem || 0) || 0,
        balance_points: parseInt(postData.balance_points || 0) || 0,
        return_amount: parseInt(returnAmnt || 0) || 0,

        // ✅ String fields
        mode: (selectedMode || "CASH").toUpperCase(),
        mobile: postData.mobile || "",
        party_name: postData.party_name || "Walk-in Customer",
        channels: postData.channels || "POS",
        address: "",
        gst_in: null,
        transaction_id:
          mergedBillDate || `TXN_${moment().format("YYYYMMDDHHmmss")}`,
        transaction_provider: 1,
        transaction_type: 1,

        // ✅ Details array (already good)
        outlet_sales_details: salesDetails,
      };

      axios
        .post("v1/outlet_sales_pending_bill", tempSaveData)
        .then((res) => {
          setPendingId(res.data.outletsalestempid);
          dispatch(
            setSnackbar(true, "success", "Sales draft saved successfully "),
          );
          window.location.reload(); // Reset form
        })
        .catch((err) => {
          dispatch(
            setSnackbar(
              true,
              "error",
              err.response?.data?.errors?.[0]?.message || "Draft save failed",
            ),
          );
        })
        .finally(() => {
          setIsLoader(false);
          setIsSavingDraft(false);
        });
    };
    useImperativeHandle(ref, () => ({
      handleNew,
    }));
    // function handleSubmit() {
    //   if (isSubmitting) return; // Prevent double submission
    //   setIsSubmitting(true); // Disable the button
    //   const uiMobile = postData.mobile?.trim();

    //   if (uiMobile && uiMobile.length !== 10) {
    //     dispatch(
    //       setSnackbar(
    //         true,
    //         "error",
    //         "Please enter valid 10-digit mobile number"
    //       )
    //     );
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   if (
    //     postData.referrer_mobile &&
    //     postData.referrer_mobile === postData.mobile
    //   ) {
    //     dispatch(
    //       setSnackbar(true, "error", "Referrer and customer cannot be same")
    //     );
    //     setIsSubmitting(false);
    //     return;
    //   }
    //   if (postData.mode?.toLowerCase() === "edc" && !openEDCStatus) {
    //     handleEDCStage();
    //     return;
    //   }
    //   if (postData.partycode === "") {
    //     dispatch(setSnackbar(true, "error", "Please select party Name"));
    //     setIsSubmitting(false);
    //   } else if (postData.outlet_sales_details.length === 0) {
    //     dispatch(setSnackbar(true, "error", "Please fill table"));
    //     setIsSubmitting(false);
    //   } else if (postData.salesman_id === "") {
    //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
    //     setIsSubmitting(false);
    //   } else if (postData.channels === "" || postData.channels === null) {
    //     dispatch(setSnackbar(true, "error", "Select Channel"));
    //     setIsSubmitting(false);
    //   } else if (postData.mode === "" || postData.mode === null) {
    //     dispatch(setSnackbar(true, "error", "Select Payment mode"));
    //     setIsSubmitting(false);
    //   } else if (postData.mode === "upi") {
    //     if (postData.mobile === "") {
    //       dispatch(
    //         setSnackbar(true, "error", "Please enter the mobile Number")
    //       );
    //       setIsSubmitting(false);
    //     } else if (postData.mobile.length !== 10) {
    //       dispatch(
    //         setSnackbar(true, "error", "Please enter 10 digit mobile Number")
    //       );
    //       setIsSubmitting(false);
    //     } else {
    //       setOpen(true);
    //     }
    //   } else if (postData.mode === "mixed") {
    //     setOpenDialog(true);
    //     setPaymentDetails((prev) => ({
    //       ...prev,
    //       cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
    //       // cash: netTotal,
    //     }));
    //   } else {
    //     handleApiData();
    //   }
    //   // setTimeout(() => setIsSubmitting(false), 2000); // Re-enable button after a delay or after operation completion
    //   // if (postData.channels === "" || postData.channels === null) {
    //   //   dispatch(setSnackbar(true, "error", "Select Channel"));
    //   //   return;
    //   // }
    // }
    // 09-12-26
    // function handleSubmit() {
    //   if (isEdcCancelled && !isEdcSuccess) {
    //     dispatch(setSnackbar(true, "error", "Retry payment"));
    //     setIsSubmitting(false);
    //     return;
    //   }
    //   if (edcUIState === "CANCELLED") {
    //     dispatch(setSnackbar(true, "error", "Payment cancelled. Please retry"));
    //     setIsSubmitting(false);
    //     return;
    //   }
    //   if (!isEdcSuccess && openEDCStatus) {
    //     console.log("🚫 EDC in progress / failed → block save");
    //     setIsSubmitting(false);
    //     return;
    //   }
    //   if (isSubmitting) return; // Prevent double submission
    //   if (isSavingDraft) return;
    //   setIsSubmitting(true); // Disable the button

    //   const uiMobile = postData.mobile?.trim();
    //   const Slipno = postData.s_no?.trim() || postData.s_no;

    //   // Optional: Validate mobile ONLY if user entered one (not forced)
    //   if (uiMobile && uiMobile.length !== 10) {
    //     dispatch(
    //       setSnackbar(
    //         true,
    //         "error",
    //         "Please enter valid 10-digit mobile number",
    //       ),
    //     );
    //     setIsSubmitting(false);
    //     return;
    //   }
    //   if (!Slipno) {
    //     dispatch(setSnackbar(true, "error", "S.No is required*"));
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   // Referrer validation
    //   if (
    //     postData.referrer_mobile &&
    //     postData.referrer_mobile === postData.mobile
    //   ) {
    //     dispatch(
    //       setSnackbar(true, "error", "Referrer and customer cannot be same"),
    //     );
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   // EDC special handling
    //   // if (postData.mode?.toLowerCase() === "edc" && !openEDCStatus) {
    //   //   handleEDCStage();
    //   //   return;
    //   // }
    //   const mode = postData.mode?.toLowerCase();

    //   // ✅ CALL EDC FOR CARD ALSO
    //   // if ((mode === "card" || mode === "edc") && !openEDCStatus) {
    //   //   handleEDCStage();
    //   //   return;
    //   // }

    //   // if (!openEDCStatus && mode === "card") {
    //   if (!openEDCStatus && mode === "card" && !isEdcSuccess) {
    //     handleEDCStage();
    //     return;
    //   }

    //   // COMMON VALIDATIONS (party, table, salesman, channel, mode)
    //   if (postData.partycode === "") {
    //     dispatch(setSnackbar(true, "error", "Please select party Name"));
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   if (postData.outlet_sales_details.length === 0) {
    //     dispatch(setSnackbar(true, "error", "Please fill table"));
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   if (postData.salesman_id === "") {
    //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   if (postData.channels === "" || postData.channels === null) {
    //     dispatch(setSnackbar(true, "error", "Select Channel"));
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   if (postData.mode === "" || postData.mode === null) {
    //     dispatch(setSnackbar(true, "error", "Select Payment mode"));
    //     setIsSubmitting(false);
    //     return;
    //   }

    //   // ✅ UPI MODE - MOBILE OPTIONAL (NEW - REPLACES OLD BLOCK)
    //   if (postData.mode === "upi") {
    //     if (!isEdcSuccess && isEdcCancelled) {
    //       dispatch(
    //         setSnackbar(true, "error", "Complete payment before saving"),
    //       );
    //       setIsSubmitting(false);
    //       return;
    //     }

    //     if (!isEdcSuccess) {
    //       handleEDCStage();
    //       return;
    //     }
    //     setOpen(true); // Open UPI dialog directly - NO mobile check!
    //     setIsSubmitting(false); // Re-enable button
    //     return;
    //   }

    //   // Mixed mode
    //   if (postData.mode === "mixed") {
    //     if (isEdcCancelled || edcUIState === "CANCELLED") {
    //       dispatch(setSnackbar(true, "error", "Retry payment"));
    //       setIsSubmitting(false);
    //       return;
    //     }
    //     setOpenDialog(true);
    //     setPaymentDetails((prev) => ({
    //       ...prev,
    //       cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
    //     }));
    //     setIsSubmitting(false); // Re-enable button
    //     return;
    //   }

    //   // All other modes (cash, card, edc) → Save directly
    //   handleApiData();
    // }

    //06-04-2026

    function handleSubmit() {
      if (isSubmitting || isSavingDraft) return;

      setIsSubmitting(true);

      const uiMobile = postData.mobile?.trim();
      const Slipno = postData.s_no?.trim() || postData.s_no;

      if (uiMobile && uiMobile.length !== 10) {
        dispatch(
          setSnackbar(
            true,
            "error",
            "Please enter valid 10-digit mobile number",
          ),
        );
        setIsSubmitting(false);
        return;
      }

      if (!Slipno) {
        dispatch(setSnackbar(true, "error", "S.No is required*"));
        setIsSubmitting(false);
        return;
      }

      if (
        postData.referrer_mobile &&
        postData.referrer_mobile === postData.mobile
      ) {
        dispatch(
          setSnackbar(true, "error", "Referrer and customer cannot be same"),
        );
        setIsSubmitting(false);
        return;
      }

      if (postData.partycode === "") {
        dispatch(setSnackbar(true, "error", "Please select party Name"));
        setIsSubmitting(false);
        return;
      }

      if (postData.outlet_sales_details.length === 0) {
        dispatch(setSnackbar(true, "error", "Please fill table"));
        setIsSubmitting(false);
        return;
      }

      if (postData.salesman_id === "") {
        dispatch(setSnackbar(true, "error", "Please Select Salesman"));
        setIsSubmitting(false);
        return;
      }

      if (postData.channels === "" || postData.channels === null) {
        dispatch(setSnackbar(true, "error", "Select Channel"));
        setIsSubmitting(false);
        return;
      }

      if (postData.mode === "" || postData.mode === null) {
        dispatch(setSnackbar(true, "error", "Select Payment mode"));
        setIsSubmitting(false);
        return;
      }

      const mode = postData.mode.toLowerCase();

      if (openEDCStatus && !isEdcSuccess) {
        dispatch(setSnackbar(true, "error", "Complete payment before saving"));
        setIsSubmitting(false);
        return;
      }

      if (mode === "card") {
        if (!openEDCStatus) {
          handleEDCStage();
        }
        setIsSubmitting(false);
        return;
      }

      if (mode === "upi") {
        setOpen(true); // 👈 Dialog opens correctly now
        setIsSubmitting(false);
        return;
      }
      if (mode === "mixed") {
        if (isEdcCancelled || edcUIState === "CANCELLED") {
          dispatch(setSnackbar(true, "error", "Retry payment"));
          setIsSubmitting(false);
          return;
        }

        setOpenDialog(true);

        setPaymentDetails((prev) => ({
          ...prev,
          cash: returnAmnt !== "" ? netTotal - returnAmnt : netTotal,
        }));

        setIsSubmitting(false);
        return;
      }
      handleApiData();
    }

    const tableData = data.map((val) => ({
      pro_name: val.pro_name,
      cat_name: val.cat_name,
      hsn: val.hsn,
      pur_rate: val.pur_rate,
      sale_rate: val.sale_rate,
      mrp: val.mrp,
      qty: val.qty,
      disc1: val.disc1,
      cgstPerc: val.gst,
      cgstAmnt: val.gstAmt,
      totalAmt: val.totalAmt,
    }));

    const TotalData = {
      returnAmnt: returnAmnt,
      sub_total: totalAmt,
      gst: gstAmt,
      totalAmount: parseFloat(Math.round(netTotal)).toFixed(0),
      roundOff: parseFloat(Math.round(netTotal).toFixed(0) - netTotal).toFixed(
        0,
      ),
    };

    const handleInputChange = (event) => {
      const { name, value } = event.target;

      const numericValue = value.replace(/[^0-9]/g, "");

      setPaymentDetails((prevDetails) => {
        const updatedDetails = { ...prevDetails, [name]: numericValue };

        const cardAmount = Number(updatedDetails.card) || 0;
        const upiAmount = Number(updatedDetails.upi) || 0;
        const totalAmount = cardAmount + upiAmount;

        const initialAmount = returnAmnt !== "" ? netTotal : netTotal;

        if (totalAmount > initialAmount) {
          updatedDetails[name] = "";
          updatedDetails.cash =
            initialAmount -
            (Number(updatedDetails.card) || 0) -
            (Number(updatedDetails.upi) || 0);
        } else {
          updatedDetails.cash = initialAmount - totalAmount;
        }

        return updatedDetails;
      });
    };

    // console.log(billPoints )
    // console.log(reward,'Reward Points','Default Point',billPoints.defaultPoint)
    let redeemPoints = 0;
    // function handleRedeem() {
    //   if (postData.mobile !== "" && postData.mobile.length===10 && op) {
    //     const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));
    //     if (netTotal >= r_amt) {
    //       const total_reward_points = parseFloat(
    //         billPoints.defaultPoint + loyalty_earned
    //       ).toFixed(0);
    //       // const total_reward_points1 = parseFloat(reward) + loyalty_earned
    //       const redemed_value = total_reward_points * (r_points / 100);
    //       const new_bal_points = total_reward_points - redemed_value;
    //       setReward(billPoints.defaultPoint + loyalty_earned);
    //       console.log(loyalty_earned,"loyal_earned ", "total_reward_points :", total_reward_points, "Reward :", billPoints.defaultPoint + loyalty_earned,"new_bal_points :",new_bal_points,"redeem :",redemed_value);
    //       // const rewardPoint = parseFloat(reward) + (totalAmt * (parseFloat(l_points) / parseFloat(l_amt)))
    //       // const updatedReward = rewardPoint - (rewardPoint * r_points / 100)

    //       // const subAmt = totalAmt - parseFloat(rewardPoint - updatedReward).toFixed(0)
    //       // setSubTot(subAmt)
    //       setRedeemedPoints(redemed_value);
    //       console.log(redeemedPonits);
    //       setThisBill(loyalty_earned);
    //       setBillPoints((prev) => ({ ...prev, total: new_bal_points }));
    //       if (redemed_value > netTotal) {
    //         // console.log('thappu', totalAmt * (r_points / 100))
    //         setPoints(Math.round(netTotal * (r_points / 100)));
    //         console.log('first')
    //         setPostData((prevState) => ({...prevState, loyalty_earned: loyalty_earned, loyalty_redem: netTotal * (r_points / 100),balance_points:parseFloat(new_bal_points).toFixed(0),}));
    //       } else {
    //         setRedeemedPoints(redemed_value);
    //         console.log(redeemedPonits);
    //         setPoints(Math.round(redemed_value).toFixed(0));
    //         console.log(points,"second");
    //         setPostData((prevState) => ({...prevState, loyalty_earned: loyalty_earned, loyalty_redem: Number(redemed_value).toFixed(0), balance_points: parseFloat(total_reward_points).toFixed(0),}));
    //       }
    //     } else {
    //       setPoints(0);
    //       setBillPoints((prev) => ({ ...prev, total: 0 }));
    //       setThisBill(0);
    //     }
    //   }
    //   else if(postData.mobile.length===10 && member){
    //     const loyalty_earned = netTotal * (parseFloat(l_points) / parseFloat(l_amt));
    //     console.log(postData.balance_points, billPoints.defaultPoint + loyalty_earned, "Enna ithu", billPoints.defaultPoint, loyalty_earned)
    //     setPostData((prevState) => ({...prevState, balance_points: billPoints.defaultPoint + loyalty_earned,}))
    //   }
    //   else{
    //     setPoints(0)
    //     setPostData((prevState) => ({...prevState, loyalty_earned: 0, loyalty_redem: 0, }));
    //     // setPostData((prevState) => ({...prevState, loyalty_earned: 0, loyalty_redem: 0, balance_points: 0,}));
    //     console.log('vara kudathu!', op)
    //   }
    // }
    // function handleNewRedeem() {
    //   if ( postData.mobile.length===10  ) {
    //     console.log(member,'Ithan da Members', billPoints, postData.balance_points)
    //     const loyalty_earned =
    //       netTotal * (parseFloat(l_points) / parseFloat(l_amt));
    //     if (netTotal >= r_amt) {
    //       const total_reward_points = parseFloat(billPoints.defaultPoint + loyalty_earned).toFixed(0);
    //       // const total_reward_points1 = parseFloat(reward) + loyalty_earned
    //       const redemed_value = total_reward_points * (r_points / 100);
    //       const new_bal_points = total_reward_points - redemed_value;
    //       setReward(billPoints.defaultPoint + loyalty_earned);
    //       console.log('Yaar ivan',loyalty_earned, "loyal_earned ", "total_reward_points :", total_reward_points, "Reward :", billPoints.defaultPoint + loyalty_earned, "new_bal_points :", new_bal_points, "redeem :", redemed_value, "third" );

    //       setPostData((prevState) => ({...prevState, loyalty_earned: loyalty_earned, loyalty_redem: 0, balance_points:  billPoints.defaultPoint + loyalty_earned,}));
    //     }
    //   }
    // }

    // const handleChange = (newValue) => {
    //   console.log(redeemedPonits, "Enna ithu", thisBill, "Loyalty earned", billPoints.defaultPoint, "Default point" );
    //   let chandru = billPoints.defaultPoint + thisBill;
    //   // setBillPoints(prev=>({...prev, total : new_bal_points}))
    //   console.log(chandru);
    //   if (/^\d*\.?\d*$/.test(newValue)) {
    //     if (newValue < redeemedPonits) {
    //       console.log(chandru - newValue, "vanthudu, fourth")
    //       setPoints(Math.round(newValue));
    //       setBillPoints((prev) => ({ ...prev, total: chandru - newValue }));
    //       setPostData((prevState) => ({
    //         ...prevState,
    //         loyalty_redem: Number(newValue).toFixed(0),
    //         balance_points: chandru - newValue,
    //       }));
    //     } else {
    //       setPoints(Math.round(redeemedPonits));
    //       setBillPoints((prev) => ({ ...prev, total: chandru - redeemedPonits }));
    //     }
    //   }
    // };
    function handleRedeem() {
      if (postData.mobile !== "" && postData.mobile.length === 10 && op) {
        const loyalty_earned =
          netTotal * (parseFloat(l_points) / parseFloat(l_amt));

        if (netTotal >= r_amt) {
          const total_reward_points = parseFloat(
            billPoints.defaultPoint,
          ).toFixed(2);
          // const total_reward_points = parseFloat(billPoints.defaultPoint + loyalty_earned).toFixed(0);
          const redemed_value = total_reward_points * (r_points / 100);
          const new_bal_points = total_reward_points - redemed_value;

          setReward(billPoints.defaultPoint + loyalty_earned);
          console.log(
            loyalty_earned,
            "loyal_earned",
            "total_reward_points :",
            total_reward_points,
            "Reward :",
            billPoints.defaultPoint + loyalty_earned,
            "new_bal_points :",
            new_bal_points,
            "redeem :",
            redemed_value,
          );

          setRedeemedPoints(redemed_value);
          setThisBill(loyalty_earned); // Update the thisBill state here
          setBillPoints((prev) => ({ ...prev, total: new_bal_points }));

          if (redemed_value > netTotal) {
            setPoints(Math.round(netTotal * (r_points / 100)));
            setPostData((prevState) => ({
              ...prevState,
              loyalty_earned: loyalty_earned,
              loyalty_redem: netTotal * (r_points / 100),
              balance_points: parseFloat(new_bal_points).toFixed(0),
              // balance_points: parseFloat(new_bal_points).toFixed(0),
            }));
          } else {
            setRedeemedPoints(redemed_value);
            setPoints(Math.round(redemed_value).toFixed(0));
            setPostData((prevState) => ({
              ...prevState,
              loyalty_earned: loyalty_earned,
              loyalty_redem: Number(redemed_value).toFixed(0),
              balance_points: parseFloat(
                new_bal_points + loyalty_earned,
              ).toFixed(0),
              // balance_points: parseFloat(total_reward_points).toFixed(0),
            }));
          }
        } else {
          setPoints(0);
          setBillPoints((prev) => ({ ...prev, total: 0 }));
          setThisBill(0); // Ensure thisBill is reset when no redemption is possible
        }
      } else if (postData.mobile.length === 10 && member) {
        const loyalty_earned =
          netTotal * (parseFloat(l_points) / parseFloat(l_amt));
        console.log(
          postData.balance_points,
          billPoints.defaultPoint + loyalty_earned,
          "Enna ithu",
          billPoints.defaultPoint,
          loyalty_earned,
        );
        console.log(
          netTotal,
          billPoints.defaultPoint,
          l_amt,
          l_points,
          "netTotal",
        );

        setPostData((prevState) => ({
          ...prevState,
          balance_points: billPoints.defaultPoint,
          // balance_points: billPoints.defaultPoint + loyalty_earned,
        }));

        setThisBill(loyalty_earned); // Ensure thisBill is updated when mobile is entered
      } else {
        setPoints(0);
        setPostData((prevState) => ({
          ...prevState,
          loyalty_earned: 0,
          loyalty_redem: 0,
        }));
        console.log("vara kudathu!", op);
      }
    }
    console.log(r_points, points, "r_points");

    function handleNewRedeem() {
      if (postData.mobile.length === 10) {
        const loyalty_earned =
          netTotal * (parseFloat(l_points) / parseFloat(l_amt));

        if (netTotal >= r_amt) {
          const total_reward_points = parseFloat(
            billPoints.defaultPoint + loyalty_earned,
          ).toFixed(0);
          const redemed_value = total_reward_points * (r_points / 100);
          const new_bal_points = total_reward_points - redemed_value;

          setReward(billPoints.defaultPoint + loyalty_earned);
          console.log(
            "Yaar ivan",
            loyalty_earned,
            "loyal_earned",
            "total_reward_points :",
            total_reward_points,
            "Reward :",
            billPoints.defaultPoint + loyalty_earned,
            "new_bal_points :",
            new_bal_points,
            "redeem :",
            redemed_value,
            "third",
          );

          setPostData((prevState) => ({
            ...prevState,
            loyalty_earned: loyalty_earned,
            loyalty_redem: 0,
            balance_points: billPoints.defaultPoint + loyalty_earned,
          }));
          setThisBill(loyalty_earned); // Update thisBill when mobile is entered
        }
      }
    }
    console.log(billPoints, thisBill, "billPoints");

    const handleChange = (newValue) => {
      let chandru = billPoints.defaultPoint + thisBill;

      if (/^\d*\.?\d*$/.test(newValue)) {
        if (newValue < redeemedPonits) {
          setPoints(Math.round(newValue));
          setBillPoints((prev) => ({ ...prev, total: chandru - newValue }));
          setPostData((prevState) => ({
            ...prevState,
            loyalty_redem: Number(newValue).toFixed(0),
            balance_points: chandru - newValue,
          }));
        } else {
          setPoints(Math.round(redeemedPonits));
          setBillPoints((prev) => ({
            ...prev,
            total: chandru - redeemedPonits,
          }));
        }
      }
    };
    console.log(points, "redeemedPonits");

    function modeCheck(mode) {
      console.log(mode, "What is mode?", netTotal, "CAsh Amount 2");
      if (mode === "cash") {
        setPostData((prev) => ({
          ...prev,
          card_amount: "0",
          cash_amount: netTotal,
          upi_amount: "0",
        }));
      } else if (mode === "card") {
        setPostData((prev) => ({
          ...prev,
          card_amount: netTotal,
          cash_amount: "0",
          upi_amount: "0",
        }));
      } else if (mode === "upi") {
        setPostData((prev) => ({
          ...prev,
          card_amount: "0",
          cash_amount: "0",
          upi_amount: netTotal,
        }));
      }
    }
    console.log(postData);
    const handleLessAmountChange = (newValue) => {
      // Convert the input value to a number
      const numericValue = parseInt(newValue, 10);
      // numericValue >= 0 &&
      // Check if the numeric value is between 0 and 9
      if (numericValue < 10) {
        console.log(newValue);
        setLessAmount(newValue);
      } else {
        // dispatch(setSnackbar(true , 'error' , 'Please enter single digit amount'))
        setLessAmount(0);
      }
    };
    const BillNO = docNameDefault
      .replace("_", "-")
      .replace("_", "-")
      .replace("_", "-");
    const currentDate = moment().format("DD-MM-YYYY-HH-mm-ss");
    // console.log(currentDate)
    // console.log(`${BillNO}${currentDate}`)
    const getMerchantID = () => {
      axios
        .get(`/v1/transaction_provider/${outlet_id}`)
        .then((res) => {
          // console.log(res.data[0])
          const providerData = res.data[0];
          setMerchantId(providerData.merchant_id);
          setUrl(providerData.url);
          setProvider(providerData);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const getPaymentType = () => {
      axios
        .get(`/v1/pay_type_master`)
        .then((res) => {
          // console.log(res.data)
          const activePayTypes = res.data.filter((item) => item.is_active);
          setpayType(activePayTypes);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // console.log(merchantId)
    // console.log(url)
    // console.log(payType)
    // const payTypeApi = (e) => {
    //   // console.log(e)
    //   if (e.pay_type_key == "1") {
    //     // console.log('Link API')
    //     handleLink();
    //   } else if (e.pay_type_key == "2") {
    //     // console.log('QR Api')
    //     handleQRCode();
    //   } else {
    //     // console.log('ISQR Api')
    //     // handleSubmit()
    //     handleApiData();
    //   }
    // };
    const payTypeApi = (e) => {
      console.log(e);
      if (e.pay_type_key == "1") {
        console.log("Link API");
        handleLink();
      } else if (e.pay_type_key == "2") {
        console.log("QR Api");
        handleQRCode();
      } else if (e.pay_type_key == "3") {
        console.log("Direct UPI");
        // handleSubmit();
        handleApiData();
      } else if (e.pay_type_key === "4") {
        handleEDCStage(); // INIT only
        setOpen(false); // close UPI dialog
        setOpenDialog(false);
      } else {
        console.log("Other payment method");
        handleApiData();
      }
    };

    const handleLink = () => {
      // setMerchantId(id)
      // console.log("handle link")
      setMergedBillDate(`${BillNO}${currentDate}`);
      const linkDataPay = {
        transactionId: `${BillNO}${currentDate}`,
        merchantOrderId: `${BillNO}`,
        amount:
          paymentDetails.upi > 0
            ? paymentDetails.upi * 100
            : parseInt(netTotal * 100),
        instrumentType: "MOBILE",
        instrumentReference: postData.mobile,
        message: "collect for XXX order",
        email: "test@gmail.com",
        expiresIn: 1800,
        shortName: "test",
        storeId: outlet_id,
        terminalId: outlet_id,
      };
      console.log(linkDataPay);
      axios
        .post(`${url}/payments/${merchantId}`, linkDataPay)
        .then((res) => {
          // console.log(res)
          // getStatusPayment()
          setOpen(false);
          setLinkOpen(true);
          setShouldPoll(true);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const handleQRCode = () => {
      // setMerchantId(id)
      // console.log(id)
      setMergedBillDate(`${BillNO}${currentDate}`);
      console.log("handle QR");
      const qrCode = {
        transactionId: `${BillNO}${currentDate}`,
        merchantOrderId: `${BillNO}`,
        amount:
          paymentDetails.upi > 0
            ? paymentDetails.upi * 100
            : parseInt(netTotal * 100),
        storeId: outlet_id,
        terminalId: outlet_id,
        expiresIn: 1800,
      };
      console.log(qrCode);
      console.log(merchantId);
      axios
        .post(`${url}/static/qrcode/generate/${merchantId}`, qrCode)
        .then((res) => {
          console.log(res.data.data.qrString);
          setQrCode(res.data.data.qrString);
          setQrOpen(true);
          setOpen(false);
          setShouldPoll(true);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // console.log(merchantId)
    // console.log(phonePayHistory)
    console.log(postData, "postdata");
    const getEdcAmount = () => {
      // Mixed payment → EDC handles card + upi
      if (postData.mode === "mixed") {
        const card = Number(paymentDetails.card || 0);
        const upi = Number(paymentDetails.upi || 0);
        return card + upi;
      }

      // Non-mixed → full amount
      return Math.round(netTotal);
    };

    // const handleEDCStage = async () => {
    //   try {
    //     if (
    //       !provider?.merchant_id ||
    //       !provider?.storeid ||
    //       !provider?.terminalid
    //     ) {
    //       dispatch(setSnackbar(true, "error", "EDC configuration missing"));
    //       setIsSubmitting(false);
    //       return;
    //     }

    //     // const transactionId = `EDC_${Date.now()}`;
    //     const transactionId = `EDC_${Date.now()}_${Math.floor(
    //       Math.random() * 1000
    //     )}`;
    //     setActiveEdcTxnId(transactionId);
    //     setEdcUIState("INIT");
    //     setEdcLoadingText("Initializing EDC terminal...");
    //     setOpenEDCStatus(true);

    //     await axios.post(
    //       `${url}/stage/edc/transaction/init/${provider.merchant_id}`,
    //       // `${url}/edc/transaction/init/${provider.merchant_id}`,
    //       {
    //         merchantId: provider.merchant_id,
    //         merchantTransactionId: transactionId,
    //         orderId: transactionId,
    //         storeId: provider.storeid,
    //         transactionId: transactionId,
    //         terminalId: provider.terminalid,
    //         amount: Math.round(netTotal) * 100,
    //         solutionType: "EDC",
    //         paymentModes: ["CARD", "DQR"],
    //         timeAllowedForHandoverToTerminalSeconds: 180,
    //         integrationMappingType: "ONE_TO_ONE",
    //       }
    //     );
    //     setEdcUIState("WAITING");
    //     pollEDCStatus(transactionId);
    //   } catch (err) {
    //     setEdcUIState("CANCELLED");
    //     setEdcLoadingText("");
    //     dispatch(setSnackbar(true, "error", "EDC init failed"));
    //   }
    // };
    // 22-01-26
    const handleEDCStage = async () => {
      try {
        if (
          !provider?.merchant_id ||
          !provider?.storeid ||
          !provider?.terminalid
        ) {
          dispatch(setSnackbar(true, "error", "EDC configuration missing"));
          setIsSubmitting(false);
          return;
        }

        // ✅ CALCULATE EDC AMOUNT CORRECTLY
        const edcAmount =
          postData.mode === "mixed"
            ? Number(paymentDetails.card || 0) + Number(paymentDetails.upi || 0)
            : Math.round(netTotal);

        if (edcAmount <= 0) {
          dispatch(setSnackbar(true, "error", "Invalid EDC amount"));
          setIsSubmitting(false);
          return;
        }

        const transactionId = `EDC_${Date.now()}_${Math.floor(
          Math.random() * 1000,
        )}`;

        setActiveEdcTxnId(transactionId);
        setEdcUIState("INIT");
        setEdcLoadingText("Initializing EDC terminal...");
        setOpenEDCStatus(true);

        let paymentModes = ["CARD", "DQR"];
        // if (postData.mode?.toLowerCase() === "card") {
        //   paymentModes = ["CARD"];
        // }
        if (postData.mode?.toLowerCase() === "card") {
          paymentModes = ["CARD"];
        } else if (postData.mode?.toLowerCase() === "upi") {
          paymentModes = ["DQR"];
        } else if (postData.mode?.toLowerCase() === "mixed") {
          const card = Number(paymentDetails.card || 0);
          const upi = Number(paymentDetails.upi || 0);

          if (card > 0 && upi === 0) {
            paymentModes = ["CARD"];
          } else if (upi > 0 && card === 0) {
            paymentModes = ["DQR"];
          }
        }
        await axios.post(
          // `${url}/stage/edc/transaction/init/${provider.merchant_id}`,
          `${url}/edc/transaction/init/${provider.merchant_id}`,
          {
            merchantId: provider.merchant_id,
            merchantTransactionId: transactionId,
            orderId: transactionId,
            storeId: provider.storeid,
            transactionId: transactionId,
            terminalId: provider.terminalid,

            // ✅ ONLY CARD + UPI GOES TO EDC
            amount: Math.round(edcAmount) * 100,

            solutionType: "EDC",
            // paymentModes: ["CARD", "DQR"],
            paymentModes: paymentModes,
            timeAllowedForHandoverToTerminalSeconds: 180,
            integrationMappingType: "ONE_TO_ONE",
          },
        );

        setEdcUIState("WAITING");
        pollEDCStatus(transactionId);
      } catch (err) {
        setEdcUIState("CANCELLED");
        setEdcLoadingText("");
        dispatch(setSnackbar(true, "error", "EDC init failed"));
      }
    };

    const handleEDCPay = async () => {
      try {
        setIsEdcPayTriggered(true);
        setEdcUIState("WAITING");
        setEdcLoadingText("Waiting for card payment...");

        await axios.post(
          // `${url}/stage/edc/pay/merchant/${provider.merchant_id}/transaction/${activeEdcTxnId}/paymentOption/CREDIT_CARD`
          `${url}/edc/pay/merchant/${provider.merchant_id}/transaction/${activeEdcTxnId}/paymentOption/${edcPaymentOption}`,
        );

        // ✅ START polling only after PAY
        pollEDCStatus(activeEdcTxnId);
      } catch (err) {
        setEdcUIState("CANCELLED");
      }
    };

    const pollEDCStatus = (transactionId) => {
      if (edcPollingInterval) {
        clearInterval(edcPollingInterval);
        setEdcPollingInterval(null);
      }

      const interval = setInterval(async () => {
        try {
          const res = await axios.post(
            // `${url}/stage/edc/transaction/status/${provider.merchant_id}/${transactionId}`
            `${url}/edc/transaction/status/${provider.merchant_id}/${transactionId}`,
          );

          const statusData = res.data?.data;
          // const status = statusData?.status;
          const txnStatus = statusData?.status;

          if (txnStatus === "SUCCESS") {
            clearInterval(interval);
            setEdcPollingInterval(null);
            setIsEdcSuccess(true); // ✅ add
            setIsEdcCancelled(false);
            handleEDCSuccess(statusData);
            return;
          }

          // if (txnStatus  === "FAILED" || status === "CANCELLED") {
          //   clearInterval(interval);
          //   setEdcPollingInterval(null);
          //   setIsEdcSuccess(false);
          //   setIsEdcCancelled(true);

          //   // resetEDC();
          //   // ✅ KEEP DIALOG OPEN (show FAILED UI)
          // setOpenEDCStatus(true);
          // setEdcUIState("FAILED");
          //   handleHistoryData(status, statusData);
          //   // setEdcUIState("CANCELLED");
          //   setEdcUIState(status);
          //   return;
          // }
          if (
            txnStatus === "FAILED" ||
            txnStatus === "CANCELLED" ||
            txnStatus === "TIMEOUT"
          ) {
            clearInterval(interval);
            setEdcPollingInterval(null);

            setIsEdcSuccess(false);
            setIsEdcCancelled(true);
            setIsEdcPayTriggered(false);

            // ✅ UI reacts based on MACHINE RESPONSE ONLY
            switch (txnStatus) {
              case "CANCELLED":
                setEdcUIState("CANCELLED");

                // ✅ close dialog only because machine said CANCELLED
                setOpenEDCStatus(false);
                break;

              case "TIMEOUT":
                setEdcUIState("TIMEOUT");
                setOpenEDCStatus(true);
                break;

              case "FAILED":
              default:
                setEdcUIState("FAILED");
                setOpenEDCStatus(true);
                break;
            }

            handleHistoryData(txnStatus, statusData);

            return;
          }
        } catch (err) {
          //     clearInterval(interval);
          //     setEdcPollingInterval(null);
          //     // setEdcUIState("CANCELLED");
          //     setIsEdcSuccess(false);
          // setIsEdcCancelled(true);
          //     setEdcUIState("FAILED");
          clearInterval(interval);
          setEdcPollingInterval(null);

          setIsEdcSuccess(false);
          setIsEdcCancelled(true);
          setIsEdcPayTriggered(false);

          setEdcUIState("FAILED");
        }
      }, 3000);

      setEdcPollingInterval(interval);
    };

    const handleManualEDCStatusCheck = async () => {
      try {
        if (!activeEdcTxnId) {
          dispatch(setSnackbar(true, "error", "No active transaction"));
          return;
        }

        const res = await axios.post(
          `${url}/edc/transaction/status/${provider.merchant_id}/${activeEdcTxnId}`,
        );

        const statusData = res.data?.data;
        const txnStatus = statusData?.status;
       const apiMessage = `Status: ${txnStatus}`;

        console.log("🔁 Manual EDC Status:", txnStatus);

        if (txnStatus === "SUCCESS") {
          setIsEdcSuccess(true);
          setIsEdcCancelled(false);
          handleEDCSuccess(statusData);
          return;
        }

        if (
          txnStatus === "FAILED" ||
          txnStatus === "CANCELLED" ||
          txnStatus === "TIMEOUT"
        ) {
          setIsEdcSuccess(false);
          setIsEdcCancelled(true);

          setEdcUIState(txnStatus);
          handleHistoryData(txnStatus, statusData);

          dispatch(setSnackbar(true, "warning", apiMessage));
          return;
        }
        dispatch(setSnackbar(true, "info", apiMessage));
      } catch (err) {
        console.error(err);
        dispatch(
          setSnackbar(
            true,
            "error",
            err.response?.data?.message || "Status check failed",
          ),
        );
      }
    };

    // const handleEDCSuccess = (data) => {
    //   setOpenEDCStatus(false);

    //   const instrument = data?.paymentInstruments?.[0] || {};
    //   const transactionId = data?.transactionId || "";
    //   const utr = instrument?.utr || data?.referenceNumber || "";

    //   const finalPayload = {
    //     ...postData,
    //     subtotal_amount: Number(totalAmt || 0),
    //     gst_amt: Number(gstAmt || 0),
    //     cess_amt: Number(cessAmt || 0),
    //     discount_amount: Number(discountamt || 0),
    //     amount: Number(Math.round(netTotal) || 0),
    //     roff: Number(Math.round(netTotal) - netTotal || 0),
    //     mode: "upi",
    //     upi_amount: Math.round(netTotal),
    //     card_amount: 0,
    //     cash_amount: 0,
    //     transaction_id: transactionId,
    //     utr: utr,
    //   };

    //   handleApiData(finalPayload);
    //   setPostData(finalPayload);
    //   handleHistoryData("SUCCESS", data);
    // };
    // 22-01-26

    const handleEDCSuccess = (data) => {
      const edcAmount = Number(data?.amount || 0) / 100;
      setIsEdcSuccess(true);
      setIsEdcCancelled(false);
      setOpenEDCStatus(false);

      const instrument = data?.paymentInstruments?.[0] || {};
      // const paymentMode = instrument?.paymentMode || instrument?.type || "";
      const paymentMode = data?.paymentMode || "";
      const isMixed = postData.mode === "mixed";
      console.log("EDC RESPONSE:", data);
      console.log("Payment Mode:", instrument);
      // const transactionId = data?.transactionId || "";
      const transactionId =
        data?.transactionId || data?.referenceNumber || instrument?.utr || "";
      const utr = instrument?.utr || data?.referenceNumber || "";

      const finalPayload = {
        ...postData,

        subtotal_amount: Number(totalAmt || 0),
        gst_amt: Number(gstAmt || 0),
        cess_amt: Number(cessAmt || 0),
        discount_amount: Number(discountamt || 0),

        amount: Number(Math.round(netTotal) || 0),
        roff: Number(Math.round(netTotal) - netTotal || 0),

        // ✅ IMPORTANT: DO NOT OVERRIDE SPLIT FOR MIXED
        // cash_amount: isMixed ? Number(paymentDetails.cash || 0) : 0,
        // card_amount: isMixed ? Number(paymentDetails.card || 0) : 0,
        // upi_amount: isMixed
        //   ? Number(paymentDetails.upi || 0)
        //   : Number(Math.round(netTotal)),
        cash_amount: isMixed ? Number(paymentDetails.cash || 0) : 0,

        // card_amount: isMixed
        //   ? Number(paymentDetails.card || 0)
        //   : paymentMode === "CARD"
        //     ? Number(Math.round(netTotal))
        //     : 0,

        // upi_amount: isMixed
        //   ? Number(paymentDetails.upi || 0)
        //   : paymentMode === "DQR"
        //     ? Number(Math.round(netTotal))
        //     : 0,
        card_amount: isMixed
          ? paymentMode === "CARD"
            ? edcAmount
            : Number(paymentDetails.card || 0)
          : paymentMode === "CARD"
            ? edcAmount
            : Number(postData.card_amount || 0),

        upi_amount: isMixed
          ? paymentMode === "DQR"
            ? edcAmount
            : Number(paymentDetails.upi || 0)
          : paymentMode === "DQR"
            ? edcAmount
            : Number(postData.upi_amount || 0),

        // ✅ MODE MUST BE MIXED IF MIXED
        // mode: isMixed ? "mixed" : "upi",
        mode: isMixed
          ? "mixed"
          : paymentMode === "CARD"
            ? "card"
            : paymentMode === "DQR"
              ? "upi"
              : postData.mode,

        transaction_id: transactionId,
        utr: utr,
      };

      handleApiData(finalPayload);
      setPostData(finalPayload);
      handleHistoryData("SUCCESS", data);
    };

    const handleRetryEDC = () => {
      setIsEdcCancelled(false);
      setIsEdcSuccess(false);
      setEdcUIState("INIT");

      handleEDCStage(); // ✅ retry
    };

    const handleCancelEDC = () => {
      resetEDC(); // full reset

      // ✅ reopen correct UI
      if (postData.mode === "mixed") {
        setOpenDialog(true);
      }
    };

    const resetEDC = () => {
      if (edcPollingInterval) {
        clearInterval(edcPollingInterval);
        setEdcPollingInterval(null);
      }

      setEdcLoadingText("");
      setIsEdcPayTriggered(false);
      setEdcUIState("INIT");
      setActiveEdcTxnId(null);
      setEdcStatus(null);
      setOpenEDCStatus(false);
      setIsSubmitting(false);
      setIsEdcSuccess(false);
      setIsEdcCancelled(false);
    };

    const getStatusPayment = () => {
      axios
        .get(`${url}/payment/status/${merchantId}/${mergedBillDate}`)
        .then((res) => {
          // const apiResposeData = res.data
          // console.log(apiResposeData)
          // console.log(responseData)
          const paymentState = res.data.data.paymentState;
          if (paymentState) {
            setPaymentState(paymentState);
            setOpen(false);
            if (paymentState === "PENDING") {
              if (qrCode) {
                setLinkOpen(false);
              } else {
                setLinkOpen(true);
              }
              setDialogOpen(false);
              setShouldPoll(true);
            } else if (paymentState === "FAILED") {
              setResponseData(res.data);
              setDialogContent("Your payment is failed. Please try again.");
              setDialogOpen(true);
              setShouldPoll(false);
              setQrOpen(false);
              setTimeout(() => {
                // handleHistoryData(res.data);
                handleHistoryData("FAILED", res.data.data);
              }, 1000);
            } else if (paymentState === "CANCELLED") {
              console.log(res.data);
              setShouldPoll(false);
              setTimeout(() => {
                // handleHistoryData(res.data);
                handleHistoryData("CANCELLED", res.data.data);
              }, 1000);
            } else if (paymentState === "COMPLETED") {
              setResponseData(res.data);
              setDialogContent("Your payment is successful.");
              setDialogOpen(true);
              setShouldPoll(false);
              setQrOpen(false);
              setTimeout(() => {
                handleHistoryData("SUCCESS", res.data.data);
              }, 1000);
              // setTimeout(() => {
              //   handleApiData()
              // },5000)
            }
          }
        })
        .catch((err) => {
          console.error("Error fetching payment status:", err);
          setIsLoader(false);
        });
    };
    // console.log(responseData)
    //   const handleHistoryData = (resData) => {
    //     console.log(resData);
    //     // console.log(responseData)
    //     // ✅ STEP 1: SAFE EXTRACTION
    // const instrument = resData?.paymentInstruments?.[0] || {};

    // const transactionId = resData?.transactionId || "";
    // const utr =
    //   instrument?.utr ||
    //   resData?.referenceNumber ||
    //   "";
    //     setPhonePayHistory((prev) => ({
    //       ...prev,
    //       // ✅ SAVE THESE FOR HISTORY TABLE
    // transaction_id: transactionId,
    // utr: utr,
    //       response_json: {
    //         data: resData,
    //       },
    //     }));
    //     // console.log(phonePayHistory);
    //     setPhonePayHistory((prevPhonePayHistory) => {
    //       axios
    //         .post(`/v1/phone_pay_history_log`, prevPhonePayHistory)
    //         .then((res) => {
    //           console.log(res);
    //         })
    //         .catch((err) => {
    //           console.log(err);
    //         });

    //       // Returning the updated state
    //       return prevPhonePayHistory;
    //     });
    //   };

    const handleHistoryData = (status, resData) => {
      if (!resData) return;

      const instrument =
        resData?.paymentInstruments?.[0] ||
        resData?.data?.paymentInstruments?.[0] ||
        {};

      const transactionId =
        resData?.transactionId ||
        resData?.data?.transactionId ||
        mergedBillDate ||
        "";

      const utr =
        instrument?.utr ||
        resData?.referenceNumber ||
        resData?.data?.referenceNumber ||
        "";

      setPostData((prev) => ({
        ...prev,
        transaction_id: transactionId,
        utr: utr,
      }));

      const payload = {
        docno: BillNO,
        transaction_date: moment().format("YYYY-MM-DD"),
        merchant_order_id: BillNO,
        transaction_id: transactionId,
        utr: utr,
        phone_no: postData.mobile,
        status: status,
        request_json: {
          request: "PHONEPE",
          transactionId: transactionId,
        },
        response_json: resData,
      };

      axios.post(`/v1/phone_pay_history_log`, payload).catch(console.error);
    };

    const handleCancelAll = () => {
      setDialogOpen(false);
      setShouldPoll(false);
      setQrOpen(false);
      setLinkOpen(false);
      setOpen(false);
    };
    useEffect(() => {
      if (dialogOpen) {
        setCountdown(3); // reset the countdown when the dialog opens

        const intervalId = setInterval(() => {
          setCountdown((prev) => {
            if (prev === 1) {
              clearInterval(intervalId);
              if (paymentState === "COMPLETED") {
                // handleApiData();
                handleCancelAll();
              } else {
                handleCancelAll();
              }
            }
            return prev - 1;
          });
        }, 1000);

        return () => {
          clearInterval(intervalId);
        };
      }
    }, [dialogOpen]);
    useEffect(() => {
      if (shouldPoll) {
        const intervalId = setInterval(getStatusPayment, 1000);
        return () => clearInterval(intervalId);
      }
    }, [shouldPoll]);
    const HandleLinkCancel = () => {
      setLinkOpen(false);
      setOpen(false);
      setShouldPoll(false);
      setIsSubmitting(false);
      axios
        .post(`${url}/cancel/payment/${merchantId}/${mergedBillDate}`)
        .then((res) => {
          // console.log(res)
          setCancelStatus(true);
          // dispatch(setSnackbar(true , "success" , "Your link payment cancel successfully!"))
          getStatusPayment();
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const handleQrCancel = () => {
      setQrOpen(false);
      setOpen(false);
      setShouldPoll(false);
      setIsSubmitting(false);
      axios
        .post(`${url}/cancel/payment/${merchantId}/${mergedBillDate}`)
        .then((res) => {
          console.log(res);
          setCancelStatus(true);
          // dispatch(setSnackbar(true , "success" , "Your QR Code payment cancel successfully!"))
          getStatusPayment();
          // handleHistoryData()
        })
        .catch((err) => {
          console.log(err);
        });
    };

    useEffect(() => {
      // if(reward!=='0'){
      axios
        .get("v1/loyalty/info/1")
        .then((res) => {
          // console.log(res.data)
          const value = res.data;
          setLAmt(value.loyalty_amount);
          setLPoints(value.loyalty_points);
          setRAmt(value.redemption_amount);
          setRPoints(value.redemption_percentage);
          // setReward(prev => parseFloat(prev) + totalAmt * value.loyalty_points / value.loyalty_amount)
        })
        .catch((err) => {
          console.log(err.response);
          dispatch(setSnackbar(true, "error", err.response.data.error));
        });
      // }
    }, []);
    // useEffect(() => {
    //   if (merchantId) {
    //     getStatusPayment(merchantId);
    //   }
    // }, [merchantId]);
    // useEffect(()=>{
    //   setPostData((prevState)=>({...prevState,  loyalty_redem : 0, }))
    // },[points])

    useEffect(() => {
      handleRedeem();
    }, [op, totalAmt, postData.mobile]);
    console.log(postData, "postData");

    useEffect(() => {
      if (!op) {
        handleNewRedeem();
      }
    }, [member, totalAmt, billPoints]);
    // useEffect(() => {
    //   setPostData((prevState) => ({
    //     ...prevState,
    //     transaction_id: mergedBillDate == "" ? "" : mergedBillDate,
    //     transaction_provider: 1,
    //     transaction_type: qrCode ? 2 : linkOpen ? 1 : 3,
    //   }));
    // }, [data, mergedBillDate, qrCode, linkOpen]);
    useEffect(() => {
      setPostData((prev) => {
        // ✅ DO NOT TOUCH EDC PAYMENTS
        if (prev.mode === "EDC") return prev;

        return {
          ...prev,
          transaction_id: prev.transaction_id || mergedBillDate || "",
          utr: prev.utr || "",
          transaction_provider: 1,
          transaction_type: qrCode ? 2 : linkOpen ? 1 : 3,
        };
      });
    }, [mergedBillDate, qrCode, linkOpen]);

    useEffect(() => {
      setPostData((prev) => ({
        ...prev,
        less_amount: parseFloat(lessAmount).toFixed(0),
      }));
    }, [lessAmount]);

    useEffect(() => {
      modeCheck(selectedMode);
      setPostData((prevState) => ({
        ...prevState,
        amount: Math.round(subNetTotal),
        // amount: Math.round(netTotal),
        cess_amt: cessAmt,
        subtotal_amount: parseFloat(totalAmt).toFixed(0),
        gst_amt: gstAmt,
        roff: parseFloat(Math.round(netTotal).toFixed(0) - netTotal),
      }));
    }, [data, lessAmount, points, selectedMode]);
    console.log(postData, "postdatacheck");

    console.log(paymentDetails.cash, "Ithan cash amount 3");
    useEffect(() => {
      setPostData((prev) => ({
        ...prev,
        card_amount: paymentDetails.card,
        cash_amount: paymentDetails.cash,
        upi_amount: paymentDetails.upi,
      }));
    }, [paymentDetails]);
    useEffect(() => {
      setPhonePayHistory((prev) => ({
        ...prev,
        docno: BillNO,
        transaction_id: mergedBillDate,
        merchant_order_id: BillNO,
        phone_no: postData.mobile,
        request_json: { data: postData },
      }));
    }, [BillNO, postData]);

    // useEffect(() => {
    //   if (responseData && Object.keys(responseData).length > 0) {
    //     setPhonePayHistory(prevState => ({
    //       ...prevState,
    //       response_json: {
    //         data: responseData
    //       }
    //     }));
    //   }
    // }, [responseData]);
    useEffect(() => {
      setPostData((prevData) => ({
        ...prevData,
        discount_amount: discountamt, // Set the calculated discount amount here
      }));
    }, [discountamt, setPostData]); // Add dependency on discountamt
    useEffect(() => {
      getMerchantID();
      getPaymentType();
    }, []);
    // console.log(gstAmt,cessAmt,parseFloat(netTotal - Math.round(netTotal)).toFixed(0), netTotal - Math.round(netTotal))
    return (
      <Fragment>
        <Typography
          variant="h6"
          textAlign="center"
          mb={2}
          sx={{ backgroundColor: "#83A2FF" }}
        >
          Total
        </Typography>
        <div className="flex p-1">
          <Typography
            textAlign="right"
            sx={{
              paddingRight: 0.4,
              fontWeight: 600,
              fontSize: 36,
              width: "100%",
            }}
          >
            {/* {Math.round(netTotal -discountamt).toFixed(0)} */}
            {netTotal}
          </Typography>
        </div>
        <div className="my-2">
          <Typography
            variant="h6"
            textAlign="center"
            mb={2}
            sx={{ backgroundColor: "#83A2FF" }}
          >
            Summary{" "}
          </Typography>
          {/* <Design title="Sub Total" value={totalAmt} /> */}

          <p
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <strong>Sub Total</strong>
            <span style={{ fontSize: 20 }}>
              <strong>{totalAmt.toFixed(2)}</strong>
            </span>
          </p>
          {/* <Design title="GST Amt" value={gstAmt} /> */}

          <p style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>GST Amt</strong>
            <span style={{ fontSize: 20 }}>
              <strong>{gstAmt.toFixed(2)}</strong>
            </span>
          </p>

          <Design title="Discount Amt" value={discountamt} />
          {/* <Design title="Cess" value={cessAmt}/> */}
          {enableRedeem ? (
            <div className="flex items-center">
              <Typography
                variant="body1"
                sx={{ fontWeight: 600, width: "100%" }}
              >
                Redeem Points
              </Typography>
              <TextField
                size="small"
                value={points}
                onChange={(e) => handleChange(e.target.value)}
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  style: {
                    textAlign: "right",
                    width: "100px",
                    fontWeight: "600",
                  },
                }}
              />
            </div>
          ) : (
            <Design title="Redeem Points" value={0} />
          )}
          {/* <Design title="Redeem Points" value={points}/> */}

          <Design
            title="Round Off"
            value={Math.round(netTotal).toFixed(0) - netTotal}
          />
          <div className="flex items-center">
            <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
              Less Amount
            </Typography>
            <TextField
              size="small"
              autoComplete="off"
              value={lessAmount}
              onChange={(e) => handleLessAmountChange(e.target.value)}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                style: {
                  textAlign: "right",
                  width: "100px",
                  fontWeight: "600",
                },
              }}
            />
          </div>
          {
            returnAmnt !== "" && (
              <Design title="Return Amount" value={returnAmnt} />
            )
            //   <div className="flex items-center">
            //   <Typography variant="body1" sx={{ fontWeight: 600, width: "100%" }}>
            //     Return Amount
            //   </Typography>
            //   <TextField size="small" value={netTotal > returnAmnt ? returnAmnt : netTotal  } onChange={(e) => handleChangeAmnt(e.target.value)} inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', style: { textAlign: 'right',width:"80px" } }} autoComplete='off'/>
            // </div>
          }
          <Design title="Net Total" value={Math.round(subNetTotal)} />
        </div>
        <Stack>
          {/* <Button size="small" sx={{margin:1}} startIcon={<Delete/>} variant="outlined" onClick={()=>setData([])}>Delete</Button>
            <Button size="small" sx={{margin:1}} startIcon={<Print/>} variant="outlined" onClick={()=>handlePrint()}>Print</Button> */}
          {/* old */}
          {/* <Button
            size="small"
            variant="contained"
            sx={{ margin: 1, backgroundColor: "blueviolet !important" }}
            startIcon={<NoteAdd />}
            onClick={() => window.location.reload()}
          >
            New
          </Button> */}
          {/* new */}
          <Button
            size="small"
            variant="contained"
            sx={{ margin: 1, backgroundColor: "blueviolet !important" }}
            startIcon={<NoteAdd />}
            onClick={handleNew}
            disabled={isSavingDraft}
          >
            {isSavingDraft ? "Saving..." : "New"}
          </Button>

          {/* <Button
            size="small"
            variant="contained"
            sx={{ margin: 1, backgroundColor: "green !important" }}
            startIcon={<Save />}
            onClick={handleSubmit}
          >
            Save
          </Button> */}
          <Button
            size="small"
            variant="contained"
            sx={{ margin: 1, backgroundColor: "green !important" }}
            startIcon={<Save />}
            onClick={handleSubmit}
            disabled={isSubmitting} // Disable button while submitting
          >
            {isSubmitting ? "Saving..." : "Save"}
          </Button>
          <Button
            size="small"
            variant="contained"
            sx={{ margin: 1, backgroundColor: "red !important" }}
            startIcon={<ExitToApp />}
            onClick={handleExit}
          >
            Exit
          </Button>
        </Stack>
        {/* <Backdrop open={open} sx={{zIndex : 1150}}>
              <Grid sx={{backgroundColor:'white', position : 'absolute', zIndex:1150, top:0,left : 0,  padding: 1}}>
            <PrintBill data={open} close={setOpen}/>
            </Grid>
            </Backdrop> */}
        <Dialog open={openDialog}>
          <DialogTitle>Mixed Payment Details</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              name="cash"
              label="Cash Amount"
              fullWidth
              value={paymentDetails.cash}
              // onChange={handleInputChange}
            />
            <TextField
              margin="dense"
              name="card"
              label="Card Amount"
              fullWidth
              value={paymentDetails.card}
              onChange={handleInputChange}
            />

            <TextField
              margin="dense"
              name="upi"
              label="UPI Amount"
              fullWidth
              value={paymentDetails.upi}
              onChange={handleInputChange}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={hanldleDialog}>
              CANCEL
            </Button>
            <Button variant="contained" onClick={handleMixedData}>
              SUBMIT
            </Button>
          </DialogActions>
        </Dialog>
        <DialogCancel
          onClickCancel={onClickCancel}
          onClickExit={onClickExit}
          dialogClose={dialogClose}
          setDialogClose={setDialogClose}
        />
        <Dialog open={open}>
          <DialogTitle
            sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
          >
            UPI Pay Details
          </DialogTitle>

          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "600px",
              height: "150px",
              padding: 3,
            }}
          >
            <Grid container spacing={2} justifyContent="center">
              {_.map(payType, (val, idx) => {
                const style = buttonStyles[idx % buttonStyles.length];
                return (
                  <Grid item key={idx}>
                    <Grid
                      // variant="outlined"
                      onClick={() => payTypeApi(val)}
                      sx={{
                        marginInline: "10px",
                        padding: "10px",
                        cursor: "pointer",
                        border: `2px solid ${style.borderColor}`,
                        borderRadius: "5px",
                        fontWeight: "bold",
                        color: style.color,
                        "&:hover": {
                          backgroundColor: style.hoverColor,
                          borderColor: style.borderColor,
                        },
                      }}
                    >
                      {val.pay_type_name}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          {/* <Button variant='outlined' onClick={() => handleLink('BLUEKODETESTUAT')}>Link</Button>
              <Button variant='outlined' sx={{marginInlineStart:"10px"}} onClick={() => handleQRCode('BLUEKODEDQRUAT')}>Show QR Code</Button>
              <Button variant='outlined' sx={{marginInlineStart:"10px"}} onClick={handleSubmit}>Direct Payment</Button> */}
          {/* </DialogContent> */}
          <DialogActions>
            <Button variant="outlined" onClick={handlePaymentClose}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={dialogOpen}>
          <DialogTitle
            sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
          >
            Payment Status
          </DialogTitle>
          <DialogContent sx={{ width: "400px", margin: "0 auto" }}>
            <img
              src={paymentState === "COMPLETED" ? success : failed}
              style={{ width: "150px", margin: "0 auto" }}
            />
            <DialogContentText sx={{ textAlign: "center" }}>
              {dialogContent}
            </DialogContentText>
            <DialogContentText sx={{ textAlign: "center", fontWeight: "bold" }}>
              Please wait {countdown.toFixed(1)} seconds...
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              // onClick={
              //   paymentState === "COMPLETED" ? handleApiData : handleCancelAll
              // }
              onClick={handleCancelAll}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={linkOpen}>
          <DialogTitle
            sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
          >
            Check Payment link in your Mobile
          </DialogTitle>
          <BarLoader color="#BA68C8" width={350} />
          <DialogActions>
            <Button variant="outlined" onClick={HandleLinkCancel}>
              Cancel Payment
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={qrOpen}>
          <DialogTitle
            sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
          >
            Scan QR to pay
          </DialogTitle>
          <DialogContent
            sx={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <QRCode value={qrCode} />
            <Grid sx={{ marginBlock: "20px" }}></Grid>
            <BarLoader color="#BA68C8" width={350} />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleQrCancel}>
              Cancel Payment
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={cancelStatus}>
          <DialogTitle
            sx={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}
          >
            Payment Cancel
          </DialogTitle>
          <DialogContent sx={{ width: "400px", margin: "0 auto" }}>
            <img src={failed} style={{ width: "150px", margin: "0 auto" }} />
            <DialogContentText sx={{ textAlign: "center" }}>
              Your payment cancel successfully!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => {
                setCancelStatus(false);
                setOpen(true);
                setShouldPoll(false);
                setQrCode("");
              }}
            >
              Retry Payment
            </Button>
            <Button
              variant="outlined"
              onClick={() => setCancelStatus(false)}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Loader isLoader={isLoader} />

        {/* EDC Terminal Dialog */}
        <Dialog open={openEDCStatus} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ textAlign: "center", fontWeight: 600 }}>
            {edcUIState === "CANCELLED" ? "Payment Cancelled" : "EDC Payment"}
          </DialogTitle>

          <DialogContent sx={{ textAlign: "center", py: 4 }}>
            {/* INIT → Initializing terminal */}
            {edcUIState === "INIT" && (
              <>
                <Typography variant="h6" mb={2}>
                  Initializing EDC terminal…
                </Typography>
                <CircularProgress />
              </>
            )}

            {/* READY → Show Pay button */}
            {edcUIState === "READY" && (
              <>
                <Typography mb={1}>Amount to Pay</Typography>
                <Typography variant="h5" mb={3}>
                  ₹{Math.round(netTotal)}
                </Typography>

                <Button variant="contained" size="large" onClick={handleEDCPay}>
                  Pay
                </Button>
              </>
            )}

            {/* WAITING → Payment in progress */}
            {edcUIState === "WAITING" && (
              <>
                <Typography mb={2}>
                  Waiting for payment confirmation…
                </Typography>
                {/* <CircularProgress /> */}
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={3}
                >
                  <CircularProgress />

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleManualEDCStatusCheck}
                  >
                    Check Status
                  </Button>
                </Stack>
              </>
            )}

            {/* CANCELLED → Failure */}
            {edcUIState === "CANCELLED" && (
              <>
                <ErrorOutlineIcon
                  sx={{ fontSize: 80, color: "error.main", mb: 2 }}
                />
                <Typography>Your payment was cancelled</Typography>
              </>
            )}
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            {/* Cancel while waiting */}
            {edcUIState === "WAITING" && (
              <Button
                color="error"
                onClick={() => {
                  resetEDC();
                  setIsSubmitting(false);
                }}
              >
                Cancel Payment
              </Button>
            )}

            {/* Retry / Close after cancel */}
            {/* {edcUIState === "CANCELLED" && (
              <>
                <Button
                  onClick={() => {
                    resetEDC();
                    handleEDCStage();
                    setIsSubmitting(false);
                  }}
                >
                  Retry Payment
                </Button>

                <Button
                  onClick={() => {
                    resetEDC();
                  }}
                >
                  Close
                </Button>
              </>
            )} */}
            {(edcUIState === "CANCELLED" || edcUIState === "FAILED") && (
              <>
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsEdcCancelled(false);
                    setIsEdcSuccess(false);
                    setEdcUIState("INIT");

                    handleEDCStage(); // 🔥 retry properly
                  }}
                >
                  Retry
                </Button>

                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    resetEDC();
                    if (postData.mode === "mixed") {
                      setOpenDialog(true);
                    }
                  }}
                >
                  Cancel
                </Button>
                {/* <Button variant="outlined" onClick={handleManualEDCStatusCheck}>
                  Check Status
                </Button> */}
              </>
            )}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  },
);

export default memo(CustomerInfo);
